<template>
  <div class="dialog-content">
    <block v-if="loading" style="z-index: 99999999 !important"></block>
    <!--div>
            
        </div-->
    <v-card-text>
      <div
        class="box mobile"
        v-if="hasDeleteBtn"
        style="
          display: flex;
          background: #41464c;
          color: white;
          padding: 10px;
          border-radius: 10px;
          justify-content: space-between;
          flex-wrap: wrap;
          z-index: 88888888 !important;
          text-align: center;
          position: sticky;
        "
      >
        <div v-if="hasDeleteBtn && !hasQoute">
          <template v-if="$store.getters['rolesUser/getCustomRole'](70) && invoice.IsTemplate">
            <v-btn
              style="margin-top: 8px"
              class="btndelete"
              color="#E3191E"
              @click.prevent="showDelAlert = true"
            >
              ELIMINAR <br />
              PLANTILLA
            </v-btn>
          </template>
          <template v-else-if="$store.getters['rolesUser/getCustomRole'](15) && !invoice.IsTemplate">
            <v-btn
              style="margin-top: 8px"
              class="btndelete"
              color="#E3191E"
              @click.prevent="showDelAlert = true"
            >
              ELIMINAR <br />
              FACTURA
            </v-btn>
          </template>
        </div>
        <div v-else-if="hasDeleteBtn &&
              hasQoute &&
              $store.getters['rolesUser/getCustomRole'](74) && invoice.IsQuote">
          <v-btn
            style="margin-top: 8px"
            class="btndelete"
            color="#E3191E"
            @click.prevent="showDelAlert = true"
          >
              ELIMINAR <br />
              COTIZACIÓN
          </v-btn>
        </div>
        
        <div
          style="
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
          "
        >
          <label class="mx-2">SubTotal</label>

          <input
            type="text"
            class="form-control"
            :value="invoice.InvoiceSubTotal.toFixed(2)"
            disabled
            aria-describedby="subtotal"
          />
          <!-- <v-text-field outlined dense  outlined dense  class="form-control" hide-details :value="invoice.InvoiceSubTotal" readonly></v-text-field> -->
        </div>
        <div
          style="
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
          "
        >
          <label>IVA</label>

          <input
            type="text"
            class="form-control"
            :value="invoice.InvoiceTotalIva.toFixed(2)"
            disabled
            aria-describedby="IVA"
          />
        </div>
        <div
          style="
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
          "
        >
          <label class="">Exentas</label>

          <input
            type="text"
            class="form-control"
            :value="invoice.InvoiceTotalExenta.toFixed(2)"
            disabled
            aria-describedby="NON-TAXABLE"
          />
        </div>

        <div
          v-if="invoice.InvoiceType == 'FNS'"
          class=""
          style="
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
          "
        >
          <label>Retención Renta</label>

          <input
            type="text"
            class="form-control"
            :value="invoice.InvoiceReteRenta.toFixed(2)"
            disabled
            aria-describedby="NON-TAXABLE"
          />
        </div>

        <div
          class=""
          style="
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
          "
        >
          <label class="">No Sujetas</label>

          <input
            type="text"
            class="form-control"
            :value="invoice.InvoiceTotalNoSuj.toFixed(2)"
            disabled
            aria-describedby="NON-TAXABLE"
          />
        </div>

        <div
          class=""
          style="
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
          "
          v-if="invoice.InvoiceTotalNoGravado > 0"
        >
          <label class="">No Gravadas</label>

          <input
            type="text"
            class="form-control"
            :value="invoice.InvoiceTotalNoGravado.toFixed(2)"
            disabled
            aria-describedby="NON-TAXABLE"
          />
        </div>

        <div
          class=""
          style="
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
          "
          v-if="invoice.TurismoPorAlojamiento > 0"
        >
          <label class="">Imp. Turismo</label>

          <input
            type="text"
            class="form-control"
            :value="invoice.TurismoPorAlojamiento.toFixed(2)"
            disabled
            aria-describedby="NON-TAXABLE"
          />
        </div>
        <!--v-row>
                        <v-col cols="12" md="6" sm="7" class="text-right align-self-center">
                            <label class="mx-2">IVA Ret 1%</label>
                        </v-col>

                        <v-col cols="12" md="6" sm="5">
                            <v-text-field outlined dense  outlined dense hide-details :value="invoice.InvoiceTotalRetTax" readonly></v-text-field>
                        </v-col>
                    </v-row-->
        <div
          class=""
          v-if="invoice.InvoiceIvaRete1 > 0 || invoice.InvoiceIvaPerce1 > 0"
          style="display: flex; flex-direction: column"
        >
          <label class="">
            {{ invoice.InvoiceIvaRete1 > 0 ? "IVA Rete" : "" }}
            {{ invoice.InvoiceIvaPerce1 > 0 ? "IVA Perce" : "" }}
          </label>

          <input
            v-if="invoice.InvoiceIvaRete1 > 0"
            type="text"
            class="form-control"
            :value="invoice.InvoiceIvaRete1.toFixed(2)"
            disabled
            aria-describedby="NON-TAXABLE"
          />

          <input
            v-if="invoice.InvoiceIvaPerce1 > 0"
            type="text"
            class="form-control"
            :value="invoice.InvoiceIvaPerce1.toFixed(2)"
            disabled
            aria-describedby="NON-TAXABLE"
          />
        </div>

        <div
          class=""
          style="
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
          "
          v-if="globalDiscountAmount > 0"
        >
          <label class="">Desc. Global</label>

          <input
            type="text"
            class="form-control"
            :value="globalDiscountAmount.toFixed(2)"
            disabled
            aria-describedby="GLOBAL-DISCOUNT"
          />
        </div>

        <div class="center" style="display: flex; flex-direction: column">
          <label class="">TOTAL</label>
          <input
            type="text"
            class="form-control"
            :value="invoice.InvoiceTotalPagar.toFixed(2)"
            disabled
            aria-describedby="VENTAS-TOTAL"
          />
        </div>

        <div>
          <v-btn
            style="margin-top: 8px"
            color="info"
            width="fit-content"
            dark
            @click.prevent="copyInvoice"
          >
            COPIAR <br />FACTURA
          </v-btn>
        </div>

        <div>
          <v-btn
            style="margin-top: 8px"
            color="info"
            width="fit-content"
            dark
            v-if="
              ((hasDeleteBtn && hasQoute) ||
                invoice.FeMhEstado == 'CONTINGENCIA' ||
                invoice.FeMhEstado == 'RECHAZADO' ||
                invoice.FeMhEstado == 'NO_PROCESADO') &&
              $store.getters['rolesUser/getCustomRole'](73)
            "
            @click="editQuote"
          >
            EDITAR <br />COTIZACIÓN
          </v-btn>
        </div>

        <div>
          <v-btn
            style="margin-top: 8px"
            color="#3498db"
            width="fit-content"
            v-if="hasPrintButtom"
            dark
            :disabled="loading"
            @click.prevent="manageprint"
          >
            IMPRIMIR <br />FACTURA 
          </v-btn>
        </div>
        <div v-if="showTicket && showOnlyThisBusiness && !invoice.IsTemplate && !invoice.IsQuote">
          <v-btn
            style="margin-top: 8px"
            color="#3498db"
            width="fit-content"
            dark
            :disabled="loading"
            @click.prevent="imprimirFacturaDirecta"
          >
            Ticket
          </v-btn>
        </div>

        <div>
          <div
            v-if="
              (hasDeleteBtn && !hasQoute) ||
              invoice.FeMhEstado == 'CONTINGENCIA' ||
              invoice.FeMhEstado == 'RECHAZADO' ||
              invoice.FeMhEstado == 'NO_PROCESADO'
            "
          >
            <div v-if="$store.getters['rolesUser/getCustomRole'](14) && !invoice.IsTemplate && !invoice.IsQuote">
              <v-btn
                style="margin-top: 8px"
                color="#3498db"
                dark
                @click="editInvoice"
              >
                <template
                  v-if="
                    invoice.FeMhEstado == 'CONTINGENCIA' ||
                    invoice.FeMhEstado == 'RECHAZADO' ||
                    invoice.FeMhEstado == 'NO_PROCESADO'
                  "
                >
                  REENVIAR <br />
                  DTE
                </template>
                <template v-else>
                  EDITAR <br />
                  FACTURA
                </template>
              </v-btn>
            </div>
            <div v-else-if="$store.getters['rolesUser/getCustomRole'](69) && invoice.IsTemplate">
              <v-btn
                style="margin-top: 8px"
                color="#3498db"
                dark
                @click="editInvoice"
              >
                  EDITAR <br />
                  PLANTILLA
              </v-btn>
            </div>
          </div>
          <div>
            <v-btn
              style="margin-top: 8px"
                class="btn-save"
              v-if="
                ((hasDeleteBtn && hasQoute) ||
                  invoice.FeMhEstado == 'CONTINGENCIA' ||
                  invoice.FeMhEstado == 'RECHAZADO' ||
                  invoice.FeMhEstado == 'NO_PROCESADO') &&
                $store.getters['rolesUser/getCustomRole'](73)
              "
              @click="editInvoice"
            >
              FACTURAR <br />
              COTIZACIÓN
            </v-btn>
          </div>
        </div>
      </div>
      <div
        class="box summaryDesktop mobile wrapper-bar"
        v-if="!hasDeleteBtn"
      >
        <div v-if="$store.getters['rolesUser/getCustomRole'](27)">
          <v-btn
            v-if="
              invoice.IsNDorNC == false &&
              invoice.FeMhEstado != 'INVALIDADO' &&
              invoice.FeMhEstado != 'CONTINGENCIA' &&
              invoice.FeMhEstado != 'RECHAZADO' &&
              invoice.FeMhEstado == 'PROCESADO' &&
              canShowInvalidateInvoice()
            "
            style="margin-top: 8px"
            class="btndelete"
            color="#E3191E"
            @click="showInvalidAlert = true"
          >
            INVALIDAR<br />FACTURA
          </v-btn>
          <v-btn 
            v-if="!['INVALIDADO', 'CONTINGENCIA', 'PROCESADO'].includes(invoice.FeMhEstado)"
            style="margin-top: 8px"
            class="btndelete"
            color="#E3191E"
            @click="showDelAlert2 = true"
          >
            ELIMINAR<br />FACTURA
          </v-btn>
        </div>

        <div class="" style="display: flex; flex-direction: column">
          <label class="">SubTotal</label>

          <input
            type="text"
            class="form-control"
            style="align-self: center"
            :value="invoice.InvoiceSubTotal.toFixed(2)"
            disabled
            aria-describedby="subtotal"
          />
          <!-- <v-text-field outlined dense  outlined dense  class="form-control" hide-details :value="invoice.InvoiceSubTotal" readonly></v-text-field> -->
        </div>
        <div class="" style="display: flex; flex-direction: column">
          <label>IVA</label>

          <input
            type="text"
            class="form-control"
            :value="invoice.InvoiceTotalIva.toFixed(2)"
            disabled
            aria-describedby="IVA"
          />
        </div>
        <div class="" style="display: flex; flex-direction: column">
          <label>Exentas</label>

          <input
            type="text"
            class="form-control"
            :value="invoice.InvoiceTotalExenta.toFixed(2)"
            disabled
            aria-describedby="NON-TAXABLE"
          />
        </div>

        <div
          v-if="invoice.InvoiceType == 'FNS'"
          class=""
          style="display: flex; flex-direction: column"
        >
          <label>Retención Renta</label>

          <input
            type="text"
            class="form-control"
            :value="invoice.InvoiceReteRenta.toFixed(2)"
            disabled
            aria-describedby="NON-TAXABLE"
          />
        </div>

        <div class="" style="display: flex; flex-direction: column">
          <label>No Sujetas</label>

          <input
            type="text"
            class="form-control"
            :value="invoice.InvoiceTotalNoSuj.toFixed(2)"
            disabled
            aria-describedby="NON-TAXABLE"
          />
        </div>

        <div class="" style="display: flex; flex-direction: column" v-if="invoice.InvoiceTotalNoGravado > 0">
          <label>No Gravadas</label>

          <input
            type="text"
            class="form-control"
            :value="invoice.InvoiceTotalNoGravado.toFixed(2)"
            disabled
            aria-describedby="NON-TAXABLE"
          />
        </div>

        <div class="" style="display: flex; flex-direction: column" v-if="invoice.TurismoPorAlojamiento > 0">
          <label>Imp. Turismo</label>

          <input
            type="text"
            class="form-control"
            :value="invoice.TurismoPorAlojamiento.toFixed(2)"
            disabled
            aria-describedby="NON-TAXABLE"
          />
        </div>
        <!--v-row>
                        <v-col cols="12" md="6" sm="7" class="text-right align-self-center">
                            <label class="mx-2">IVA Ret 1%</label>
                        </v-col>

                        <v-col cols="12" md="6" sm="5">
                            <v-text-field outlined dense  outlined dense hide-details :value="invoice.InvoiceTotalRetTax" readonly></v-text-field>
                        </v-col>
                    </v-row-->
        <div
          class=""
          style="display: flex; flex-direction: column"
          v-if="invoice.InvoiceIvaRete1 > 0 || invoice.InvoiceIvaPerce1 > 0"
        >
          <label>
            {{ invoice.InvoiceIvaRete1 > 0 ? "IVA Rete" : "" }}
            {{ invoice.InvoiceIvaPerce1 > 0 ? "IVA Perce" : "" }}
          </label>

          <input
            v-if="invoice.InvoiceIvaRete1 > 0"
            type="text"
            class="form-control"
            style="align-self: center"
            :value="invoice.InvoiceIvaRete1.toFixed(2)"
            disabled
            aria-describedby="NON-TAXABLE"
          />

          <input
            v-if="invoice.InvoiceIvaPerce1 > 0"
            type="text"
            class="form-control"
            style="align-self: center"
            :value="invoice.InvoiceIvaPerce1.toFixed(2)"
            disabled
            aria-describedby="NON-TAXABLE"
          />
        </div>

        <div
          class=""
          style="display: flex; flex-direction: column"
          v-if="globalDiscountAmount > 0"
        >
          <label>Desc. Global</label>

          <input
            type="text"
            class="form-control"
            :value="globalDiscountAmount.toFixed(2)"
            disabled
            aria-describedby="GLOBAL-DISCOUNT"
          />
        </div>

        <div class="" style="display: flex; flex-direction: column">
          <label>TOTAL</label>
          <input
            type="text"
            class="form-control totalDesignGlobal"
            style="align-self: center"
            :value="invoice.InvoiceTotalPagar.toFixed(2)"
            disabled
            aria-describedby="VENTAS-TOTAL"
          />
        </div>

        <div>
          <v-btn
            style="margin-top: 8px"
            color="info"
            dark
            @click.prevent="copyInvoice"
            v-if="!hiddenNDDC"
          >
            COPIAR <br />FACTURA
          </v-btn>
        </div>

        <div v-if="$store.getters['rolesUser/getCustomRole'](26)">
          <v-btn
            style="margin-top: 8px"
            color="#3498db"
            v-if="hasPrintButtom && invoice.IsNDorNC == false"
            dark
            :disabled="loading"
            @click.prevent="manageprint"
          >
            IMPRIMIR <br />FACTURA 
          </v-btn>
        </div>
        <div v-if="$store.getters['rolesUser/getCustomRole'](26) &&
        showTicket && showOnlyThisBusiness">
          <v-btn
            style="margin-top: 8px"
            color="#3498db"
            v-if="hasPrintButtom && invoice.IsNDorNC == false"
            dark
            :disabled="loading"
            @click.prevent="imprimirFacturaDirecta"
          >
            Ticket
          </v-btn>
        </div>

        <v-btn
          style="margin-top: 8px"
          color="#3498db"
          dark
          v-if="
            (hasDeleteBtn ||
            invoice.FeMhEstado == 'CONTINGENCIA' ||
            invoice.FeMhEstado == 'RECHAZADO' ||
            invoice.FeMhEstado == 'NO_PROCESADO') && !hiddenNDDC
          "
          @click="editInvoice"
        >
          <template v-if="invoice.IsTemplate">
            EDITAR <br />
            PLANTILLA
          </template>
          <template
            v-else-if="
              invoice.FeMhEstado == 'CONTINGENCIA' ||
              invoice.FeMhEstado == 'RECHAZADO' ||
              invoice.FeMhEstado == 'NO_PROCESADO'
            "
          >
            REENVIAR <br />
            DTE
          </template>
          <template v-else>
            EDITAR <br />
            FACTURA
          </template>
        </v-btn>
      </div>
      <div
        class="summaryMobile mobile"
        v-if="!hasDeleteBtn"
        style="
          background: #41464c;
          color: white;
          padding: 10px;
          border-radius: 10px;

          z-index: 88888888 !important;

          text-align: center;
          position: sticky;
        "
      >
        <div style="overflow: hidden; display: flex; flex-direction: column">
          <div cl>
            <v-btn
              v-if="
                invoice.IsNDorNC == false &&
                invoice.FeMhEstado != 'INVALIDADO' &&
                invoice.FeMhEstado != 'CONTINGENCIA' &&
                invoice.FeMhEstado != 'RECHAZADO' &&
                canShowInvalidateInvoice()
              "
              :style="`margin-top: 8px;${
                $vuetify.breakpoint.smAndDown ? '' : 'float: left;'
              }`"
              class="btndelete"
              color="#E3191E"
              @click="showInvalidAlert = true"
            >
              INVALIDAR<br />FACTURA
            </v-btn>
          </div>
          <div
            class=""
            style="
              float: left;
              align-items: center;
              display: flex;
              flex-direction: column;
            "
          >
            <label class="">SubTotal</label>

            <input
              type="text"
              class="form-control"
              :value="invoice.InvoiceSubTotal.toFixed(2)"
              disabled
              aria-describedby="subtotal"
            />
            <!-- <v-text-field outlined dense  outlined dense  class="form-control" hide-details :value="invoice.InvoiceSubTotal" readonly></v-text-field> -->
          </div>
          <div
            class=""
            style="
              float: left;
              align-items: center;
              display: flex;
              flex-direction: column;
            "
          >
            <label>IVA</label>

            <input
              type="text"
              class="form-control"
              :value="invoice.InvoiceTotalIva.toFixed(2)"
              disabled
              aria-describedby="IVA"
            />
          </div>
          <div
            class=""
            style="
              float: left;
              align-items: center;
              display: flex;
              flex-direction: column;
            "
          >
            <label>Exentas</label>

            <input
              type="text"
              class="form-control"
              :value="invoice.InvoiceTotalExenta.toFixed(2)"
              disabled
              aria-describedby="NON-TAXABLE"
            />
          </div>

          <div
            v-if="invoice.InvoiceType == 'FNS'"
            class=""
            style="
              float: left;
              align-items: center;
              display: flex;
              flex-direction: column;
            "
          >
            <label>Retención Renta</label>

            <input
              type="text"
              class="form-control"
              :value="invoice.InvoiceReteRenta.toFixed(2)"
              disabled
              aria-describedby="NON-TAXABLE"
            />
          </div>
        </div>

        <div style="overflow: hidden; display: flex; flex-direction: column">
          <div
            class=""
            style="
              float: left;
              align-items: center;
              display: flex;
              flex-direction: column;
            "
          >
            <label>No Sujetas</label>

            <input
              type="text"
              class="form-control"
              :value="invoice.InvoiceTotalNoSuj.toFixed(2)"
              disabled
              aria-describedby="NON-TAXABLE"
            />
          </div>
          <div
            class=""
            style="
              float: left;
              align-items: center;
              display: flex;
              flex-direction: column;
            "
            v-if="invoice.TurismoPorAlojamiento > 0"
          >
            <label>No Sujetas</label>

            <input
              type="text"
              class="form-control"
              :value="invoice.TurismoPorAlojamiento.toFixed(2)"
              disabled
              aria-describedby="NON-TAXABLE"
            />
          </div>
          <div
            class=""
            style="
              float: left;
              align-items: center;
              display: flex;
              flex-direction: column;
            "
            v-if="invoice.InvoiceTotalNoGravado > 0"
          >
            <label>No Gravadas</label>

            <input
              type="text"
              class="form-control"
              :value="invoice.InvoiceTotalNoGravado.toFixed(2)"
              disabled
              aria-describedby="NON-TAXABLE"
            />
          </div>
          <!--v-row>
                          <v-col cols="12" md="6" sm="7" class="text-right align-self-center">
                              <label class="mx-2">IVA Ret 1%</label>
                          </v-col>
  
                          <v-col cols="12" md="6" sm="5">
                              <v-text-field outlined dense  outlined dense hide-details :value="invoice.InvoiceTotalRetTax" readonly></v-text-field>
                          </v-col>
                      </v-row-->
          <div
            class=""
            style="display: flex; flex-direction: column"
            v-if="invoice.InvoiceIvaRete1 > 0 || invoice.InvoiceIvaPerce1 > 0"
          >
            <label>
              {{ invoice.InvoiceIvaRete1 > 0 ? "IVA Rete" : "" }}
              {{ invoice.InvoiceIvaPerce1 > 0 ? "IVA Perce" : "" }}
            </label>

            <input
              v-if="invoice.InvoiceIvaRete1 > 0"
              type="text"
              class="form-control"
              style="align-self: center"
              :value="invoice.InvoiceIvaRete1.toFixed(2)"
              disabled
              aria-describedby="NON-TAXABLE"
            />

            <input
              v-if="invoice.InvoiceIvaPerce1 > 0"
              type="text"
              class="form-control"
              style="align-self: center"
              :value="invoice.InvoiceIvaPerce1.toFixed(2)"
              disabled
              aria-describedby="NON-TAXABLE"
            />
          </div>

          <div
            class=""
            style="
              float: left;
              align-items: center;
              display: flex;
              flex-direction: column;
            "
            v-if="globalDiscountAmount > 0"
          >
            <label>Desc. Global</label>

            <input
              type="text"
              class="form-control"
              :value="globalDiscountAmount.toFixed(2)"
              disabled
              aria-describedby="GLOBAL-DISCOUNT"
            />
          </div>
          
          <div
            class=""
            style="
              float: left;
              align-items: center;
              display: flex;
              flex-direction: column;
            "
          >
            <label>TOTAL</label>
            <input
              type="text"
              class="form-control totalDesignGlobal"
              style="align-self: center"
              :value="invoice.InvoiceTotalPagar.toFixed(2)"
              disabled
              aria-describedby="VENTAS-TOTAL"
            />
          </div>

          <v-btn
            style="margin-top: 8px; float: left; align-self: center"
            color="info"
            dark
            @click.prevent="copyInvoice"
          >
            COPIAR <br />FACTURA
          </v-btn>

          <v-btn
            style="margin-top: 8px; float: left; align-self: center"
            color="#3498db"
            v-if="hasPrintButtom && invoice.IsNDorNC == false"
            dark
            :disabled="loading"
            @click.prevent="manageprint"
          >
            IMPRIMIR <br />FACTURA
          </v-btn>
          <div v-if="$store.getters['rolesUser/getCustomRole'](26) &&
            showTicket && showOnlyThisBusiness">
            <v-btn
              style="margin-top: 8px"
              color="#3498db"
              v-if="hasPrintButtom && invoice.IsNDorNC == false"
              dark
              :disabled="loading"
              @click.prevent="imprimirFacturaDirecta"
            >
              Ticket
            </v-btn>
          </div>

          <v-btn
            style="margin-top: 8px; float: left; width: 28%; align-self: center"
            color="save"
            dark
            v-if="
              hasDeleteBtn ||
              invoice.FeMhEstado == 'CONTINGENCIA' ||
              invoice.FeMhEstado == 'RECHAZADO' ||
              invoice.FeMhEstado == 'NO_PROCESADO'
            "
            @click="editInvoice"
          >
            <template v-if="invoice.IsTemplate">
              EDITAR <br />
              PLANTILLA
            </template>
            <template
              v-else-if="
                invoice.FeMhEstado == 'CONTINGENCIA' ||
                invoice.FeMhEstado == 'RECHAZADO' ||
                invoice.FeMhEstado == 'NO_PROCESADO'
              "
            >
              REENVIAR <br />
              DTE
            </template>
            <template v-else>
              EDITAR <br />
              FACTURA
            </template>
          </v-btn>
        </div>
      </div>
      <v-row class="mt-2 mb-2" v-if="invoice.Invoice_Status == 1">
        <v-col cols="12" md="6">
          <h3 v-if="invoice.FeMhEstado == 'PROCESADO'" style="color: green !important;"><b>Estado de la factura:</b> {{ invoice.FeMhEstado }}</h3>  
          <h3 v-else-if="invoice.FeMhEstado == 'INVALIDADO'" style="color: red !important;">
            <b>Estado de la factura:</b> {{ invoice.FeMhEstado }}
            <br/>
            <b>Fecha de invalidación:</b> {{ invalidDate }}
            <br/>
            <b>Id de usuario que realizo la invalidación:</b> {{ invoice.InvalidatedIdUser }}
            <br/>
            <b>Usuario que realizo la invalidación:</b> {{ invoice.InvalidatedLegalNameUser }}
          </h3> 
          <h3 v-else><b>Estado de la factura:</b> {{ invoice.FeMhEstado }}</h3>  
        </v-col>
      </v-row>
      <v-card-title
        class="text-h5 d-flex mb-4 justify-space-between align-center"
      >
        <div>
          <v-btn color="primary" @click="showCustomer = !showCustomer">
            <v-icon>mdi-file-account</v-icon>
          </v-btn>
          <!-- update customer data -->
          <v-btn class="ml-2" v-if="hasUpdateCustomerBtn" color="primary" @click="updateCustomerData">
            Actualizar<br>
            Datos Cliente
          </v-btn>
          <v-btn
            class="ml-2"
            v-if="canEditSelectors"
            color="primary"
            @click="openEditSelectorsDialog"
          >
            Editar<br />
            clasificaciones
          </v-btn>
          <!-- edit frequency button for templates -->
          <v-btn 
            class="ml-2" 
            v-if="invoice.IsTemplate && $store.getters['rolesUser/getCustomRole'](69) && UseRecurringTemplates" 
            color="primary" 
            @click="openFrequencyModal"
          >
            Configurar frecuencia
          </v-btn>
        </div>

        <p class="subtitle-1"><b>ID:</b> {{ invoice.ID_Invoice }}</p>
        <p
          class="subtitle-1"
          v-if="authFeActive == 1 && invoice.Invoice_Status == 1"
        >
          <b>Número de control: </b> {{ invoice.NumeroControl }}
          <br />
          <b>Código de generación: </b>
          {{ invoice.CodigoGeneracion || invoice.CodigoGeneracionInvalidacion }}
        </p>
        <!--p v-if="!hasDeleteBtn">
          <b>ID Legal:</b> {{ invoice.Legal_ID_Invoice }}
        </p-->
        <!--div>
          <v-btn text class="close-icon" @click="$emit('close')">
                    <v-icon>mdi-close</v-icon>
                </v-btn>
        </div-->
      </v-card-title>
      <v-row style="text-align: right">
        <v-col cols="12">
          <v-btn
            style="margin: 1rem 0"
            color="#3498db"
            v-if="
              keyMaster == '22ddfc1b81d28286daec551efa268b0d' ||
              keyMaster == '1f4e233a5eef560814ecf400f0e4c642'
            "
            dark
            @click.prevent="managePrintDeliveryDoc"
          >
            IMPRIMIR DOCUMENTO DE ENTREGA
          </v-btn>
        </v-col>
      </v-row>
      <v-row class="mt-4">
        <!-- <v-col cols="1">
                    <v-btn class="btn-save" @click="showCustomer = !showCustomer"><v-icon>mdi-file-account</v-icon></v-btn>
                  </v-col> -->
        <v-col
          :cols="12"
          :md="invoice.Legal_ID_Invoice === 'No hay correlativo' ? 6 : 4"
        >
          <date-picker
            :label="$t('vwinvoices_creationdate')"
            :value="date"
            v-model="date"
            :disbaled="true"
          ></date-picker>
        </v-col>
        <v-col
          :cols="12"
          :md="invoice.Legal_ID_Invoice === 'No hay correlativo' ? 6 : 4"
        >
          <v-select
            outlined
            dense
            attach
            v-model="invoice.InvoiceType"
            :items="filterType"
            item-text="name"
            item-value="key"
            label="Tipo de factura"
            readonly
          >
          </v-select>
        </v-col>
        <v-col cols="4">
          <v-text-field
            v-if="invoice.Legal_ID_Invoice != 'No hay correlativo'"
            outlined
            dense
            v-model="invoice.Legal_ID_Invoice"
            label="ID Legal"
            readonly
          >
          </v-text-field>
        </v-col>
      </v-row>
      <v-row>
        <v-col
          cols="12"
          :md="invoice.InvoiceStatusDescription != 'Crédito' ? 6 : 4"
        >
          <!-- <v-select outlined dense v-model="invoice.InvoicePaymentType" attach :items="paymentTypes" label="Método de pago" readonly>
          </v-select> -->
          <v-select
            v-if="invoicePayments.length == 0"
            outlined
            dense
            v-model="invoice.InvoicePaymentType"
            attach
            :items="paymentTypes.map((current) => current.Valores)"
            label="Método de pago"
            class="fast-ease-in-transitioned-element"
            :rules="required"
            readonly
          >
          </v-select>
          <v-btn
            v-else
            class="btn-save mb-3"
            @click="showPayments = !showPayments"
            >Ver método de pago</v-btn
          >
        </v-col>

        <v-col
          cols="12"
          :md="invoice.InvoiceStatusDescription != 'Crédito' ? 6 : 4"
        >
          <v-select
            outlined
            dense
            attach
            v-model="invoice.InvoiceStatusDescription"
            :items="['Cancelada', 'Pendiente de pago', 'Crédito', 'Anulada']"
            label="Estado de la factura"
            readonly
          >
          </v-select>
        </v-col>
        <v-col cols="12" sm="6" md="4" v-if="invoice && invoice.InvoiceReference">
           <v-text-field
            outlined
            dense
            v-model="invoice.InvoiceReference"
            readonly
            label="N. Referencia"
          ></v-text-field>
        </v-col>

        <v-col cols="12" sm="6" md="4">
          <v-select
            outlined
            dense
            attach
            v-if="invoice.InvoiceStatusDescription == 'Crédito'"
            v-model="invoice.InvoiceCreditDay"
            :items="[
              '8 días',
              '15 días',
              '30 días',
              '90 días',
              '120 días',
              '180 días',
            ]"
            label="Días de crédito"
            readonly
          >
          </v-select>
        </v-col>
      </v-row>
      <v-row v-if="invoice.IsTemplate && invoice.IsRecurring">
        <v-col cols="12">
          <v-divider></v-divider>
          <h4 style="color: #336699; margin: 16px 0 10px 0;">Configuración de Facturación Recurrente</h4>
        </v-col>
        <v-col cols="12" sm="6" md="4">
          <v-text-field
            outlined
            dense
            :value="invoice.PaymentFrequencyDays"
            label="Frecuencia de pagos (días)"
            readonly
            prepend-inner-icon="mdi-calendar-range"
          ></v-text-field>
        </v-col>
        <v-col cols="12" sm="6" md="4">
          <v-text-field
            outlined
            dense
            :value="formatDateDDMMYYYY(invoice.NextInvoiceDate)"
            label="Próxima fecha de facturación"
            readonly
            prepend-inner-icon="mdi-calendar-check"
          ></v-text-field>
        </v-col>
      </v-row>

      <v-row>

        <v-col cols="12" sm="6" md="4" v-if="invoice.InvoiceType != 'FCF'">
          <v-text-field
            outlined
            dense
            v-model="invoice.InvoiceNRC"
            readonly
            :label="$t('vwinvoices_invoicenrc')"
          ></v-text-field>
        </v-col>
        <v-col cols="12" sm="6" md="4" v-if="invoice.InvoiceDUI">
          <v-text-field
            outlined
            dense
            v-model="invoice.InvoiceDUI"
            readonly
            label="DUI"
          ></v-text-field>
        </v-col>
        <v-col cols="12" sm="6" md="4" v-if="invoice.InvoiceType != 'FCF'">
          <v-text-field
            outlined
            dense
            v-model="invoice.InvoiceNIT"
            readonly
            :label="$t('vwinvoices_invoicenit')"
          ></v-text-field>
        </v-col>

        <v-col cols="12" sm="6" md="4" v-if="invoice.InvoiceType != 'FCF'">
          <v-text-field
            outlined
            dense
            v-model="invoice.InvoiceEntity"
            readonly
            :label="$t('vwinvoices_invoiceentity')"
          >
          </v-text-field>
        </v-col>

        <v-col cols="12" sm="6" md="4" v-if="invoice.InvoiceType != 'FCF'">
          <v-text-field
            outlined
            dense
            v-model="invoice.InvoiceTaxPayerSize"
            readonly
            :label="$t('vwinvoices_invoicetaxpayersize')"
          ></v-text-field>
        </v-col>

        <v-col cols="12" sm="6" md="4" v-if="invoice.InvoiceType != 'FCF'">
          <v-text-field
            outlined
            dense
            v-model="invoiceDteJson.ReceptorDescActividad"
            readonly
            label="Actividad Económica"
          >
          </v-text-field>
        </v-col>
        <v-col cols="12" sm="6" md="4">
          <v-checkbox
            v-model="invoice.IsNonTaxable"
            readonly
            :label="$t('vwinvoices_cclientisnontaxable')"
          >
          </v-checkbox>
        </v-col>
        <v-col cols="12">
          <h3
            :class="!invoice.InvoiceInternalNote ? 'tabs' : 'tabsContent'"
            @click="showComment = !showComment"
          >
            Comentarios
          </h3>
          <v-dialog v-model="showComment" max-width="1000">
            <v-card>
              <v-card-title class="text-h5">Comentario de factura</v-card-title>
              <v-card-text>
                <quill-editor
                  v-model="invoice.InvoiceInternalNote"
                  :label="$t('vwinvoices_invoicenotes')"
                  readonly
                >
                </quill-editor>
              </v-card-text>
              <v-card-actions>
                <v-col class="text-right">
                  <v-btn @click="showComment = !showComment" class="btndisable">
                    Continuar
                  </v-btn>
                </v-col>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </v-col>
        <v-col cols="4"></v-col>
        <v-col cols="4"></v-col>
      </v-row>

      <div class="mt-10">
        <h3 v-if="invoice.IsNDorNC == true">
          SELECCIONE LOS PRODUCTOS A MODIFICAR PARA CREAR LA NOTA DE CRÉDITO O
          DÉBITO
        </h3>
        <h3 v-if="invoice.InvoiceType == 'DNR'">
          SELECCIONE LOS PRODUCTOS PARA REALIZAR UNA FACTURA A PARTIR DE UNA NOTA DE REMISIÓN
        </h3>
        <p v-if="invoice.IsNDorNC == false" class="mb-4">
          {{ $t("vwinvoices_currentinvoiceitems") }}
        </p>
        <v-simple-table dense>
          <template v-slot:default>
            <thead>
              <tr>
                <th v-if="invoice.IsNDorNC == true || invoice.InvoiceType == 'DNR'"> 
                  <v-checkbox
                    v-model="selectAll"
                    @change="toggleSelectAll"
                    :disabled="getSelectableInvoiceItems().length === 0"
                    hide-details
                    dense
                  ></v-checkbox>
                </th>
                <th class="text-left" v-if="invoice.InvoiceType == 'FNS'">Cuenta Contable</th>
                <th class="text-left" v-if="invoice.InvoiceType == 'FNS'">Cuenta Contable</th>
                <th class="text-left">ID</th>
                <th class="text-left">Descripción Producto/Servicio</th>
                <th class="text-left" v-if="invoice.InvoiceType == 'DNR'">Vigentes</th>
                <th class="text-left">
                  {{ invoice.IsNDorNC == true ? "Cantidad original" : "Cantidad" }}
                </th>
                <th class="text-left" v-if="invoice.IsNDorNC == true && DoDndDncInHistoryInvoices">
                  Cantidad a facturar
                </th>
                <th class="text-left">Precio Unitario</th>
                <th class="text-left" v-if="invoice.IsNDorNC == true && DoDndDncInHistoryInvoices">
                  Precio Unitario a facturar
                </th>
                <th class="text-left">Descuento</th>
                <th class="text-left">Otros montos no afectos</th>
                <th class="text-left">Exenta</th>
                <th class="text-left">No Sujeta</th>
                <th class="text-left">Total</th>
                <th class="text-left" v-if="invoice.IsNDorNC == true && DoDndDncInHistoryInvoices">
                  Total a facturar
                </th>
                <th class="text-left" v-if="DeliveryControl">Estado</th>
                <th v-if="invoice.InvoiceType == 'DNR'">Detalle</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="item in invoiceItems" :key="item.uuid || item.Pk_billing_invoices_details || item.ID_Item">
                <td v-if="invoice.IsNDorNC == true || invoice.InvoiceType == 'DNR'">
                  <template v-if="item.ID_Item != 'SERVPROPINAS'">
                    <v-checkbox 
                      :value="item"
                      v-model="invoiceSelectItems"
                      :disabled="!isInvoiceItemSelectable(item)"
                      hide-details
                      dense>
                    </v-checkbox>
                  </template>
                </td>

                <td v-if="invoice.InvoiceType == 'FNS'">
                  <template> 
                    <a href="#" @click="addAccountingCodeByItem(item)">
                      <v-icon>mdi-pencil</v-icon>
                    </a>
                  </template>
                </td>
                <td v-if="invoice.InvoiceType == 'FNS'">
                  {{ getAccountCatalog(item?.ID_AccountCatalog) }}
                </td>
                <td>
                  {{ item.ID_Item }}
                </td>
                <td>{{ item.ItemDescription }}</td>
                <td v-if="invoice.InvoiceType == 'DNR'">{{ getVisibleItemQuantity(item) }}</td>
                <td>{{ item.ItemQuantity }}</td>
                <td v-if="invoice.IsNDorNC == true && isHistoryNDNC">
                  <template v-if="item.ID_Item != 'SERVPROPINAS'">
                    <v-text-field
                      v-model.number="item.NdNcQuantity"
                      type="number"
                      min="0"
                      :max="getNdNcOriginalQuantity(item)"
                      step="0.0001"
                      dense
                      outlined
                      hide-details
                      class="ndnc-quantity-field"
                      @blur="normalizeNdNcQuantity(item)"
                    ></v-text-field>
                  </template>
                  <template v-else>
                    ---
                  </template>
                </td>
                <td>
                  {{ item.ItemCurrency == "USD" ? "$" : item.ItemCurrency
                  }}{{ item.ItemUnitPrice.toFixed(4) }}
                </td>
                <td v-if="invoice.IsNDorNC == true && isHistoryNDNC">
                  <template v-if="item.ID_Item != 'SERVPROPINAS'">
                    <v-text-field
                      v-model.number="item.NdNcUnitPrice"
                      type="number"
                      min="0"
                      step="0.0001"
                      dense
                      outlined
                      hide-details
                      class="ndnc-unit-price-field"
                      @blur="normalizeNdNcUnitPrice(item)"
                    ></v-text-field>
                  </template>
                  <template v-else>
                    ---
                  </template>
                </td>
                <td>
                  {{ item.ItemCurrency == "USD" ? "$" : item.ItemCurrency
                  }}{{ item.ItemDiscount.toFixed(4) }}
                </td>
                <td>
                  {{ item.ItemCurrency == "USD" ? "$" : item.ItemCurrency
                  }}{{ item.ItemNoGravada.toFixed(4) }}
                </td>
                <td>
                  {{ item.ItemCurrency == "USD" ? "$" : item.ItemCurrency
                  }}{{ item.ItemExenta.toFixed(4) }}
                </td>
                <td>
                  {{ item.ItemCurrency == "USD" ? "$" : item.ItemCurrency
                  }}{{ item.ItemNoSuj.toFixed(4) }}
                </td>
                <td>
                  {{ item.ItemCurrency == "USD" ? "$" : item.ItemCurrency
                  }}{{ item.ItemGravada.toFixed(4) }}
                </td>
                <td v-if="invoice.IsNDorNC == true && DoDndDncInHistoryInvoices">
                  <template v-if="item.ID_Item != 'SERVPROPINAS'">
                    {{ formatNdNcAmount(item, getNdNcLineNetAmount(item)) }}
                  </template>
                  <template v-else>
                    ---
                  </template>
                </td>
                <td v-if="DeliveryControl">
                  <template v-if="item.ItemType == 'product'">
                    {{ item.IsDelivered?'Entregado':'En proceso' }} {{ getDateFormatted(item.DeliveryDate) }}
                  </template>
                  <template v-else>
                    ---
                  </template>
                </td>
                <td v-if="invoice.InvoiceType == 'DNR'">
                  <v-btn
                    small
                    dark
                    color="#3498db"
                    :disabled="getDnrRelationsByItem(item).length === 0"
                    @click="openDnrRelatedDialog(item)"
                  >
                    Ver
                  </v-btn>
                </td>
              </tr>
            </tbody>
          </template>
        </v-simple-table>
        <v-dialog v-model="showDnrRelatedDialog" max-width="1100">
          <v-card>
            <v-card-title class="text-h5">
              Detalle relacionado DNR
              <span v-if="selectedDnrRelatedItem" class="ml-2">
                - {{ selectedDnrRelatedItem.ID_Item }}
              </span>
            </v-card-title>
            <v-card-text>
              <template v-if="getSelectedDnrRelations().length > 0">
                <v-simple-table dense>
                  <template v-slot:default>
                    <thead>
                      <tr>
                        <th class="text-left">Factura relacionada</th>
                        <th class="text-left">ID item</th>
                        <th class="text-left">Descripción</th>
                        <th class="text-left">Cantidad facturada</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="relation in getSelectedDnrRelations()" :key="relation.ID">
                        <td>{{ relation.ID_InvoiceRelated }}</td>
                        <td>{{ getInvoiceItemCodeByPkId(relation.Pk_ID_Item) }}</td>
                        <td>{{ getInvoiceItemDescriptionByPkId(relation.Pk_ID_Item) }}</td>
                        <td>{{ relation.QuantityBilled }}</td>
                      </tr>
                    </tbody>
                  </template>
                </v-simple-table>
              </template>
              <p v-else class="mb-0">No se encontraron registros relacionados para esta nota de remisión.</p>
            </v-card-text>
            <v-card-actions>
              <v-col class="text-right">
                <v-btn @click="showDnrRelatedDialog = false" class="btndisable">
                  Cerrar
                </v-btn>
              </v-col>
            </v-card-actions>
          </v-card>
        </v-dialog>

        <div class="d-flex flex-wrap justify-space-between align-start my-4">
          <v-btn 
            v-if="invoice.InvoiceType == 'DNR'"
            color="#3498db"
            dark
            @click="createAnInvoiceFrom()"
            >Realizar factura a partir de una Nota de Remisión</v-btn>
          <v-btn
            v-if="invoice.IsNDorNC == true && !isHistoryNDNC"
            color="#3498db"
            dark
            @click="addNDorNC('DNC')"
            >Relacionar Nota de Crédito</v-btn
          >
          <v-btn
            v-if="invoice.IsNDorNC == true && !isHistoryNDNC"
            color="#3498db"
            dark
            @click="addNDorNC('DND')"
            >Relacionar Nota de Débito</v-btn
          >
          <v-btn
            v-if="invoice.IsNDorNC == true && isHistoryNDNC"
            color="#2E86C1"
            dark
            :disabled="loading"
            @click="directInvoiceNdNc('DNC')"
            >Facturar Nota de Crédito</v-btn
          >
          <v-btn
            v-if="invoice.IsNDorNC == true && isHistoryNDNC"
            color="#2E86C1"
            dark
            :disabled="loading"
            @click="directInvoiceNdNc('DND')"
            >Facturar Nota de Débito</v-btn
          >
          <!-- class="summ"  p>{{$t('vwinvoices_totalinletters')}}</p-->
          <!--div>
                        {{invoice.InvoiceTotal_InLetters}}
                    </div-->
        </div>
      </div>

      <v-dialog
        v-model="showCustomer"
        scrollable
        :max-width="$vuetify.breakpoint.smAndDown ? '90%' : '1000px'"
      >
        <v-card>
          <v-card-title class="text-h5">Información del cliente </v-card-title>
          <v-card-text class="pa-5">
            <v-row>
              <v-col cols="12" md="6">
                <v-text-field
                  outlined
                  dense
                  readonly
                  v-model="invoice.InvoiceName"
                  :label="$t('vwinvoices_clegalname')"
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="6">
                <v-text-field
                  outlined
                  dense
                  readonly
                  v-model="invoice.InvoiceAddress"
                  :label="$t('vwinvoices_clegaladdress')"
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="2" v-if="!invoice.isa_business">
                <v-text-field
                  outlined
                  dense
                  readonly
                  v-model="invoice.InvoiceDUI"
                  label="DUI"
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="2">
                <v-text-field
                  outlined
                  dense
                  readonly
                  v-model="invoice.InvoiceNIT"
                  :label="$t('vwinvoices_clegalnit')"
                ></v-text-field>
              </v-col>

              <v-col cols="12" md="2">
                <v-text-field
                  outlined
                  dense
                  readonly
                  v-model="invoice.InvoiceNRC"
                  :label="$t('vwinvoices_clegalnrc')"
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="3">
                <v-text-field
                  outlined
                  dense
                  readonly
                  v-model="invoice.InvoiceEntity"
                  :label="$t('vwinvoices_clegalentity')"
                ></v-text-field>
              </v-col>

              <v-col cols="12" md="3">
                <v-text-field
                  outlined
                  dense
                  readonly
                  v-model="invoice.InvoiceTaxPayerSize"
                  :label="$t('vwinvoices_clegaltaxpayersize')"
                >
                </v-text-field>
              </v-col>
              <v-col cols="12" md="5">
                <v-text-field
                  outlined
                  dense
                  readonly
                  v-model="invoice.InvoiceSector"
                  :label="$t('vwinvoices_clegalsector')"
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="4">
                <v-text-field
                  outlined
                  dense
                  readonly
                  v-model="invoice.Invocie_Legal_ID_Reference"
                  :label="$t('vwinvoices_clegalinformation')"
                ></v-text-field>
              </v-col>
              <v-col class="align-self-center" cols="12" md="3">
                <v-checkbox
                  :value="invoice.legalisnontaxable"
                  readonly
                  v-model="invoice.InvoiceIsNonTaxable"
                  :label="$t('vwinvoices_cclientisnontaxable')"
                ></v-checkbox>
              </v-col>
              <!--<v-col cols="12" lg="4">
                                            <v-select outlined dense  :items="['Foo', 'Bar', 'Fizz', 'Buzz']" label="Payment Type" attach>
                                                <template v-slot:item="{ item, attrs, on }">
                                                    <v-list-item v-bind="attrs" v-on="on">
                                                        <v-list-item-title :id="attrs['aria-labelledby']" v-text="item"
                                                        ></v-list-item-title>
                                                    </v-list-item>
                                                </template>
                                            </v-select>
                                        </v-col>-->
              <v-col cols="12"></v-col>
            </v-row>
            <v-row>
              <v-col cols="10"></v-col>
              <v-col cols="2"
                ><v-btn class="btndisable" @click="showCustomer = !showCustomer"
                  >Continuar</v-btn
                ></v-col
              >
            </v-row>
          </v-card-text>
        </v-card>
      </v-dialog>

      <v-dialog
        v-model="showPayments"
        scrollable
        :max-width="$vuetify.breakpoint.smAndDown ? '90%' : '1000px'"
      >
        <v-card>
          <v-card-title class="text-h5"> Método de pago </v-card-title>
          <v-card-text>
            <DxDataGrid :data-source="invoicePayments" :show-borders="true">
              <DxColumn
                data-field="DescriptionTypePayment"
                caption="Tipo de pago"
              />
              <DxColumn data-field="TotalPayment" caption="Total" />
              <DxColumn data-field="Reference" caption="N. Referencia" />
            </DxDataGrid>
          </v-card-text>
          <v-card-actions class="text-right">
            <v-btn class="btndisable" @click="showPayments = false"
              >Continuar</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-dialog
        v-model="showEditSelectorsDialog"
        :max-width="$vuetify.breakpoint.smAndDown ? '90%' : '1000px'"
      >
        <v-card>
          <v-card-title class="text-h5">Clasificación para anexos</v-card-title>
          <v-card-text>
            <v-form ref="editSelectorsFormRef" v-model="editSelectorsValid">
              <v-row class="mt-6 ml-2 mr-2">
                <v-col cols="12" md="4">
                  <ClasificationRentaAutocomplete
                    v-model="editSelectorsForm.ClasificationRent"
                    required
                  />
                </v-col>
                <v-col cols="12" md="4">
                  <v-select
                    outlined
                    dense
                    v-model="editSelectorsForm.SectorProveedores"
                    :items="sectorProveedores"
                    item-text="Valores"
                    item-value="Codigo"
                    attach
                    clearable
                    label="Sector"
                  ></v-select>
                </v-col>
                <v-col cols="12" md="4">
                  <v-select
                    outlined
                    dense
                    v-model="editSelectorsForm.TipoIngresoProveedores"
                    :items="tipoIngresoProveedores"
                    item-text="Valores"
                    item-value="Codigo"
                    attach
                    clearable
                    label="Tipo de Costo / Gasto"
                  ></v-select>
                </v-col>
                <v-col cols="12">
                  <small>
                    Los campos <b>Tipo de Costo / Gasto</b> y <b>Sector</b> son opcionales; si no se seleccionan, se tomarán los valores predeterminados del proveedor.
                  </small>
                </v-col>
              </v-row>
            </v-form>
          </v-card-text>
          <v-card-actions class="justify-end">
            <v-btn text @click="closeEditSelectorsDialog" :disabled="editSelectorsLoading">
              Cancelar
            </v-btn>
            <v-btn color="primary" @click="saveEditSelectors" :loading="editSelectorsLoading">
              Guardar
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-dialog
        v-model="showDelAlert"
        :max-width="$vuetify.breakpoint.smAndDown ? '90%' : '500px'"
      >
        <v-card v-if="showDelAlert" class="text-center">
          <v-card-title class="text-h5">
            ¿Esta seguro de eliminar esta factura?
          </v-card-title>

          <v-btn class="ma-2" large color="info" @click="deleteInvoice">
            Si
          </v-btn>

          <v-btn class="ma-2" large color="error" @click="showDelAlert = false">
            No
          </v-btn>
        </v-card>
      </v-dialog>

      <v-dialog
        v-model="showDelAlert2"
        :max-width="$vuetify.breakpoint.smAndDown ? '90%' : '500px'"
      >
        <v-card v-if="showDelAlert2" class="text-center">
          <v-card-title class="text-h5">
            ¿Esta seguro de eliminar esta factura?
          </v-card-title>

          <v-btn class="ma-2" large color="info" @click="deleteInvoiceWithInventory">
            Si
          </v-btn>

          <v-btn class="ma-2" large color="error" @click="showDelAlert2 = false">
            No
          </v-btn>
        </v-card>
      </v-dialog>

      <v-dialog
        v-model="showInvalidAlert"
        :max-width="$vuetify.breakpoint.smAndDown ? '90%' : '500px'"
      >
        <v-card v-if="showInvalidAlert" class="text-center">
          <template>
            <v-card-title class="text-h5">
              ¿Esta seguro de invalidar esta factura?

              <v-row class="mt-2">
                <v-col cols="12">
                <v-text-field
                  outlined
                  dense
                  v-model="invalidForm.motivoInvalid"
                  :rules="motivoInvalidRules"
                  label="Motivo de invalidación"
                ></v-text-field>
                </v-col>
                <v-col cols="12">
                <v-select
                  outlined
                  dense
                  attach
                  v-model="invalidForm.tipo"
                  :items="invalidForm.tipoInvalid"
                  item-text="value"
                  item-value="id"
                  label="Seleccione el tipo de invalidación"
                >
                </v-select>
                </v-col>
              </v-row>

              <!--v-checkbox
                v-if="isCarsem"
                outlined
                dense
                attach
                v-model="invalidForm.IsReturn"
                label="Es devolución?"
              >
              </v-checkbox-->
            </v-card-title>

            <v-btn
              class="ma-2"
              large
              color="info"
              @click="invalidDTE(invalidForm)"
            >
              Invalidar
            </v-btn>

            <v-btn
              class="ma-2"
              large
              color="error"
              @click="showInvalidAlert = false"
            >
              Cancelar
            </v-btn>
          </template>

          <!--template v-if="invoice.InvoiceType == 'CCF'">
            <v-card-title class="text-h5">
              ¿Esta seguro de invalidar esta factura de crédito fiscal?

              <v-text-field outlined dense v-model="invalidForm.motivoInvalid"
                label="Motivo de invalidación"></v-text-field>

              <v-select outlined dense attach v-model="invalidForm.tipo" :items="invalidForm.tipoInvalid"
                item-text="value" item-value="id" label="Seleccione el tipo de invalidación">
              </v-select>
            </v-card-title>

            <v-btn class="ma-2" large color="info" @click="invalidDTE(invalidForm)">
              Invalidar CCF
            </v-btn>

            <v-btn class="ma-2" large color="error" @click="showInvalidAlert = false">
              Cancelar
            </v-btn>
          </template-->
        </v-card>
      </v-dialog>
    </v-card-text>
    <alerts
      v-if="alert.show"
      v-on:close_alert="closeAlert"
      v-on:accept_alert="acceptAlert"
      :properties="alert"
    >
    </alerts>
    <template v-if="isFCF">
      <print-pos-factura
        :hideQr="hideQr"
        :dataRegular="print"
        :dataTicket="print3"
        v-if="!customer?.IsISSS"
      ></print-pos-factura>
      <PrintPosFaMed  v-if="customer?.IsISSS" :hideQr="hideQr" :dataProps="print"></PrintPosFaMed>
    </template>
    <template v-else>
      <PrintPosFaMed  v-if="infobusiness.ID_KeyMaster === 'e05f325e05113060116d3d03ea7de431' || customer?.IsISSS" :hideQr="hideQr" :dataProps="print"></PrintPosFaMed>
      <PrintPosFacturaSolAmbiental v-else-if="infobusiness.ID_KeyMaster === '7accd5a9b298117d5fd9b94c54d8f97f'" :hideQr="hideQr" :dataProps="print"></PrintPosFacturaSolAmbiental>
      <print-pos-fa-ciade-v1  v-else-if="infobusiness.ID_KeyMaster === '3f3355bdc105555f5c6fe11bfd1e5021'" v-model="showFacPrint" :hideQr="hideQr" :dataProps="print"></print-pos-fa-ciade-v1>
      <print-pos-coco-teams  v-else-if="infobusiness.ID_KeyMaster === 'c050f33ac72b1e37cdbe728fa5b50d29'" v-model="showFacPrint" :hideQr="hideQr" :dataProps="print"></print-pos-coco-teams>
      <template v-else>
        <print-pos-fa v-if="!customer?.IsISSS" :hideQr="hideQr" :dataProps="print"></print-pos-fa>
      </template>
    </template>

    <PrintPosTk :dataProps="print2"></PrintPosTk>

    <PrintPosDteLetter :hideQr="hideQr" :dataProps="printLetter"></PrintPosDteLetter>

    <!-- <PrintPosTkFcf :hideQr="hideQr" :dataProps="print3"></PrintPosTkFcf> -->

    <PrintPosDeliveryDoc
      :hideQr="true"
      :dataProps="printDeliveryDoc1"
    ></PrintPosDeliveryDoc>

    <block v-if="loading"></block>

    <v-dialog v-model="showAccountingForm" scrollable width="70%" style="z-index: 160;">
        <ExpenseDialog
          :newAccountList="accountList"
          :newSelectedExpense="selectedExpense"
          :action="action"
          @handleAction="handleAction"
        />
      </v-dialog>
  </div>
</template>

<script>
import DatePicker from "../../components/DatePicker";
import Alerts from "@/components/Alerts";
import PrintPosDeliveryDoc from "../../components/ReportsAndPrintings/PrintPosDeliveryDoc";
import PrintPosFa from "../../components/ReportsAndPrintings/PrintPosFa";
import PrintPosFaCiadeV1 from "../../components/ReportsAndPrintings/PrintPosFaCiadeV1";
import PrintPosCocoTeams from "../../components/ReportsAndPrintings/PrintPosCocoTeams";
import PrintPosFaMed from "../../components/ReportsAndPrintings/PrintPosFaMed";
import PrintPosFacturaSolAmbiental from "../../components/ReportsAndPrintings/PrintPosFacturaSolAmbiental";
import PrintPosTk from "../../components/ReportsAndPrintings/PrintPosTk";
import PrintPosDteLetter from "../../components/ReportsAndPrintings/PrintPosDteLetter.vue";
// import PrintPosTkFcf from "../../components/ReportsAndPrintings/PrintPosTkFcf";
import Block from "@/components/Block";
import { mapGetters } from "vuex";
import { DxDataGrid, DxColumn } from "devextreme-vue/data-grid";
import {
  VUE_APP_CARSEM_ID_KEYMASTER1,
  VUE_APP_CARSEM_ID_KEYMASTER2,
  VUE_APP_CARSEM_ID_KEYMASTER3,
} from "../../config";
import PrintPosFactura from "../../components/ReportsAndPrintings/PrintPosFactura.vue";
import { imprimirFactura } from "../../utils/printInvoice";
import { generateUUID } from "../../helpers/misc";
import { numberToText } from "../../helpers/conveterNumberText";
import { resolveBranchConfiguredDteTemplate } from "../../helpers/dteTemplateSettings";
import ExpenseDialog from "../acounting/ExpenseDialog.vue";
import ClasificationRentaAutocomplete from "../../components/Misc/ClasificationRentaAutocomplete.vue";
function getStoredUser() {
    try {
        return JSON.parse(localStorage.getItem("user")) || {};
    } catch (error) {
        return {};
    }
}

function isMypeEnabled(value) {
    if (value === undefined || value === null || value === "") {
        return false;
    }

    if (typeof value === "boolean") {
        return value;
    }

    return ["1", "true"].includes(String(value).trim().toLowerCase());
}
export default {
  name: "InvoiceDetails",
  props: {
    invoice: {
      type: Object,
      default: () => {},
    },
    hasDeleteBtn: {
      type: Boolean,
      default: false,
    },
    hasUpdateCustomerBtn: {
      type: Boolean,
      default: true,
    },
    hasUpdateSelectorsBtn: {
      type: Boolean,
      default: true,
    },
    hasQoute: {
      type: Boolean,
      default: false,
    },
    hasPrintButtom: {
      type: Boolean,
      default: false,
    },
    hideQr: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    DatePicker,
    Alerts,
    PrintPosFa,
    Block,
    PrintPosTk,
    PrintPosDteLetter,
    DxDataGrid,
    DxColumn,
    // PrintPosTkFcf,
    PrintPosDeliveryDoc,
    PrintPosFactura,
    PrintPosFacturaSolAmbiental,
    PrintPosFaMed,
    PrintPosFaCiadeV1,
    PrintPosCocoTeams,
    ExpenseDialog,
    ClasificationRentaAutocomplete
  },
  data() {
    const storedUser = getStoredUser();
    return {
      invoiceDetailAttemptKey: null,
      invoiceDetailAttemptUncertain: false,
      invoiceDetailRequestInFlight: false,
      loading: false,
      print: {
        show: false,
        data: [],
      },
      print2: {
        show: false,
        data: [],
      },
      print3: {
        show: false,
        data: [],
      },
      printLetter: {
        show: false,
        data: [],
      },
      printDeliveryDoc1: {
        show: false,
        data: [],
      },
      windowsList: [],
      showFacPrint: false,
      nativeDteTemplateEnabled: false,
      userinfo: JSON.parse(localStorage.getItem("user")),
      branchinfo: JSON.parse(localStorage.getItem("branch")),
      keyMaster: JSON.parse(localStorage.getItem("user")).keymaster,
      ticketdirectprinting: JSON.parse(localStorage.getItem("user")).ticketdirectprinting || 0,
      DeliveryControl: JSON.parse(localStorage.getItem("user")).deliverycontrol || 0,
      UseRecurringTemplates: JSON.parse(localStorage.getItem("user")).userecurringtemplates || 0,
      DoDndDncInHistoryInvoices: JSON.parse(localStorage.getItem("user")).dodnddncinhistoryinvoices || 0,
      alert: {
        type: "success",
        show: false,
        header: "",
        body: "",
      },
      form: {},
      date: null,
      invoiceItems: [],
      invoiceDteJson: {
        ReceptorDescActividad: null,
      },
      invoiceDocRelated: [],
      dnrRelatedItems: [],
      dnrRelatedItemsLoaded: false,
      invoiceSelectItems: [],
      totalItemsPrice: null,
      showDelAlert: false,
      showDelAlert2: false,
      showInvalidAlert: false,
      showEditSelectorsDialog: false,
      editSelectorsValid: false,
      editSelectorsLoading: false,
      editSelectorsForm: {
        ClasificationRent: null,
        SectorProveedores: null,
        TipoIngresoProveedores: null,
      },
      searchbusiness: {},
      infobusiness: {},
      header: {},
      footer: {},
      showCustomer: false,
      showComment: false,
      required: [(v) => !!v || "Este campo es requerido"],
      invalidForm: {
        motivoInvalid: "",
        tipo: 2,
        tipoInvalid: [
          { id: 2, value: "Rescindir de la operación realizada." },
        ],
        IsReturn: false,
      },
      filterType: [
        {
          name: "CONSUMIDOR FINAL",
          key: "FCF",
        },
        {
          name: "CRÉDITO FISCAL",
          key: "CCF",
        },
        {
          name: "SUJETO EXCLUIDO",
          key: "FNS",
        },
        {
          name: "EXPORTACIÓN",
          key: "FEX",
        },
        {
          name: "NOTA DE CRÉDITO",
          key: "DNC",
        },
        {
          name: "NOTA DE DÉBITO",
          key: "DND",
        },
        {
          name: "COMPROBANTE DE DONACIÓN",
          key: "CDD",
        },
        {
          name: "NOTA DE REMISIÓN",
          key: "DNR",
        },
      ],
      motivoInvalidRules: [
        (value) => {
          if (value) return true;

          return "Este campo es requerido.";
        },
        (value) => {
          if (value.length < 5)
            return "La longitud mínima de este campo es 5 caracteres";

          if (value.length > 250)
            return "La longitud máxima de este campo es 250 caracteres";

          return true;
        },
      ],
      authFeActive: JSON.parse(localStorage.getItem("FaMh")).AuthFeActive,
      invoicePayments: [],
      showPayments: false,
      customer: null,
      selectAll: false,
      showDnrRelatedDialog: false,
      selectedDnrRelatedItem: null,
      accountList: {},
      selectedExpense: {
        ExpenseName: null,
        ID: null,
        CatalogName: null,
      },
      action: {
        ADD: false,
        EDIT: false,
        DEL: false,
        ADD_ONE: false,
      },
      showAccountingForm: false,
      invoiceDncOrDndToDeleting: null,
      TipoPlan: storedUser.TipoPlan || null,
    };
  },
  watch:{
    invoiceSelectItems(val) {
      const selectableItemsLength = this.getSelectableInvoiceItems().length;
      this.selectAll = selectableItemsLength > 0 && val.length === selectableItemsLength;
    }
  },
  computed: {
    ...mapGetters(["getCatalogMH"]),
    isFCF() {
      return (
        JSON.parse(localStorage.getItem("user")).ticketformatfcf &&
        JSON.parse(localStorage.getItem("user")).TipoPlan != "Ecoanual" &&
        (this.invoice.InvoiceType == "FCF" || this.invoice.InvoiceType == "CCF" )
      );
    },
    paymentTypes() {
      return this.getCatalogMH("FormaPago");
    },
    tipoIngresoProveedores() {
      return this.getCatalogMH("TipoIngresoProveedores");
    },
    sectorProveedores() {
      return this.getCatalogMH("SectorProveedores");
    },
    canEditSelectors() {
      return (
        this.hasUpdateSelectorsBtn &&
        this.invoice &&
        this.invoice.InvoiceType === "FNS" &&
        this.invoice.ID_Invoice &&
        this.invoice.ID_Business
      );
    },
    isCarsem() {
      const keyMastersArray = JSON.parse(this.getCookie("ID_KeyMaster"));
      const specialKeyMasters =
        keyMastersArray.includes(VUE_APP_CARSEM_ID_KEYMASTER1) ||
        keyMastersArray.includes(VUE_APP_CARSEM_ID_KEYMASTER2) ||
        keyMastersArray.includes(VUE_APP_CARSEM_ID_KEYMASTER3);
      if (specialKeyMasters) {
        return true;
      } else {
        return false;
      }
    },
    invalidDate() {
      if (
        this.invoice &&
        this.invoice.FeMhEstado === "INVALIDADO" &&
        this.invoice.InvalidDate
      ) {
        const date = new Date(this.invoice.InvalidDate);
        return `${date.toLocaleDateString()} ${date.toLocaleTimeString()}`;
      }
      else if (
        this.invoice &&
        this.invoice.FeMhEstado === "INVALIDADO" &&
        this.invoice.SystemDateUpdate
      ) {
        const date = new Date(this.invoice.SystemDateUpdate);
        return `${date.toLocaleDateString()} ${date.toLocaleTimeString()}`;
      }
      return "";
    },
    showTicket() {
      return (
        JSON.parse(localStorage.getItem('user')).ticketformatfcf && 
        JSON.parse(localStorage.getItem('user')).TipoPlan != 'Ecoanual' && this.TipoPlan != 'Ecoanual CONAMYPE' &&
        (this.invoice.InvoiceType == 'FCF' || this.invoice.InvoiceType == 'CCF' || this.invoice.InvoiceType == 'TCKS')
      )
    },
    showOnlyThisBusiness() {
      if (this.isEnabledFlag(this.ticketdirectprinting)) {
        return true
      }
      else {
        return false
      }
    },
    isMype() {
            return isMypeEnabled(getStoredUser().ismype);
    },
    isHistoryNDNC(){
      return (this.isMype || ['Ecoanual CONAMYPE'].includes(this.TipoPlan) || this.DoDndDncInHistoryInvoices)
    },
    hiddenNDDC(){
      return ['DND', 'DNC'].includes(this.invoice.InvoiceType) && this.isHistoryNDNC;
    },
    globalDiscountAmount() {
      return this.roundValue(
        this.getNumberValue(this.invoice.InvoiceDescuNoSuj) +
          this.getNumberValue(this.invoice.InvoiceDescuExenta) +
          this.getNumberValue(this.invoice.InvoiceDescuGravada),
        2
      );
    },

  },
  mounted() {
    this.searchbusiness.branch =
      JSON.parse(localStorage.getItem("user")).branch || "";
    this.searchbusiness.business =
      JSON.parse(localStorage.getItem("user")).businessid || "";
    this.initialDataCall();
    this.date = this.invoice.InvoiceDate;
    this.DoDndDncInHistoryInvoices = (this.isMype || ['Ecoanual CONAMYPE'].includes(this.TipoPlan) || this.DoDndDncInHistoryInvoices);
  },
  methods: {
    async submitInvoiceAttempt(request) {
      if (this.invoiceDetailRequestInFlight || this.invoiceDetailAttemptUncertain) {
        throw new Error('Hay un intento pendiente. Revise el historial antes de continuar.');
      }
      const key = this.invoiceDetailAttemptKey || this.$API.invoices.newIdempotencyKey();
      this.invoiceDetailAttemptKey = key;
      this.invoiceDetailRequestInFlight = true;
      try {
        const result = await request(key);
        this.invoiceDetailAttemptKey = null;
        return result;
      } catch (error) {
        this.invoiceDetailAttemptUncertain = !!(error?.transportFailure || error?.status === 409 || error?.status === 503);
        if (!this.invoiceDetailAttemptUncertain) this.invoiceDetailAttemptKey = null;
        if (this.invoiceDetailAttemptUncertain) {
          sessionStorage.setItem('lastUncertainInvoiceDetailAttempt', key);
          try {
            const status = await this.$API.invoices.getInvoiceAttemptStatus(key);
            const completed = status?.data?.state === 'COMPLETED';
            error.message = `El resultado no se confirmó. Revise el historial antes de continuar.${status?.data?.ID_Invoice ? ` ID de factura: ${status.data.ID_Invoice}.` : ''}`;
            if (completed) error.message += ' El intento terminó; abra la factura desde el historial.';
          } catch (statusError) {
            error.message = 'El resultado no se confirmó. Revise el historial antes de continuar.';
          }
        }
        throw error;
      } finally {
        this.invoiceDetailRequestInFlight = false;
      }
    },
    isEnabledFlag(value) {
      return value === true || value === 1 || value === "1" || value === "true";
    },
    hasValue(value) {
      return value !== undefined && value !== null && value !== "";
    },
    getFirstValue(values = [], fallback = "") {
      for (const value of values) {
        if (this.hasValue(value)) {
          return value;
        }
      }

      return fallback;
    },
    getNumberValue(value, fallback = 0) {
      const numericValue = parseFloat(value);
      return Number.isFinite(numericValue) ? numericValue : fallback;
    },
    roundValue(value, decimals = 8) {
      const factor = Math.pow(10, decimals);
      return Math.round((this.getNumberValue(value) + Number.EPSILON) * factor) / factor;
    },
    formatDateForInvoice(date = new Date()) {
      const day = String(date.getDate()).padStart(2, "0");
      const month = String(date.getMonth() + 1).padStart(2, "0");
      const year = date.getFullYear();
      return `${day}/${month}/${year}`;
    },
    acceptAlert() {
      //Do nothing
    },
    async handleAction({ action, ...data } = {}) {
      this.showAccountingForm = false
      if(action === "error") {
        this.showAlert("warning", "Advertencia", "Código contable seleccionado es invalido.")
      }
      else {
        if (this.action.ADD_ONE) {
          const item = this.invoiceItems.find(item => item.uuid === this.selectedExpense.uuid)

          if (item) {
            item.CatalogName = data.CatalogName
            item.ID_AccountCatalog = data.ID_AccountCatalog
            item.AccountCode = data.AccountCode

            this.$API.invoices.updateAccountCatalogByItemInvoice(item)
              .then(response => {
                if (response?.success) {
                  this.showAlert("success", "Exito", response.message)
                }
                else {
                  this.showAlert("warning", "Advertencia", response.message)
                }
              }).catch(err => {
                console.log(err)
                this.showAlert("warning", "Advertencia", "No se pudo actualizar la cuenta contable del elemento de factura seleccionado.")
              })
            
          }
          console.log("VEAMOS 1", this.selectedExpense)
          console.log("VEAMOS 2", data)
          
        }
      }
    },
    getAccountCatalog(ID_AccountCatalog){
      console.log(this.accountList);
      const account = this.accountList.filter((item) => item.id_account == ID_AccountCatalog);
      if (!account || account.length == 0) {
        return 'Sin asignar';
      }
      
      return account[0]?.account_code + ' ' + account[0]?.account_description;
    },
    addAccountingCodeByItem(data) {
      this.selectedExpense = data
      this.showAccountingForm = true
      this.action.ADD_ONE = true
      this.action.ADD = false
    }, 
    getAllAcounts() {
      try {
        this.$API.branchaccountcatalog
          .getActiveBranchAccountCatalog()
          .then(({ data }) => {
            this.accountList = data;
          });
      } catch (error) {
        console.log(error);
      }
    },
    async getCustomer() {
      await this.$API.customers
        .getOneCustomer(this.invoice.ID_Customer)
        .then((res) => {
          this.customer = res;
          this.invoice.customerEmail =
            res.Email || res.BusinessEmail || res.BusinessContactEmail;
        })
        .catch((err) => {
          console.log("ERROR CUSTOMER", err);
        });
    },
    async updateCustomerData() {
      try {
        this.loading = true;
        const { data } = await this.$API.invoices.updateInvoiceCustomer(
          this.invoice.ID_Invoice)
        this.$emit("updateCustomerData", data.message + ". Es necesario consultar nuevamente la información");
      } catch(err) {
        console.log(err)
        const msg = this.$parseError(err)
        this.showAlert('danger', 'Error', msg);
      } finally {
        this.loading = false;
      }
    },
    getCookie(cname) {
      let name = cname + "=";
      let decodedCookie = decodeURIComponent(document.cookie);
      let ca = decodedCookie.split(";");
      for (let i = 0; i < ca.length; i++) {
        let c = ca[i];
        while (c.charAt(0) == " ") {
          c = c.substring(1);
        }
        if (c.indexOf(name) == 0) {
          return c.substring(name.length, c.length);
        }
      }
      return "";
    },
    async initialDataCall() {
      this.loading = true;
      if (
        this.invoice.InvoiceType == "DNC" ||
        this.invoice.InvoiceType == "DND"
      ) {
        await Promise.all([
          this.getHeaderFooter(),
          this.getInfoBranch(),
          this.getInvoiceProductItems(),
          this.getInvoiceServiceItems(),
          this.getDteJsonHeaderInfo(),
          this.getDocRelated(),
          this.getCustomer(),
        ]);
      } else {
        await Promise.all([
          this.getHeaderFooter(),
          this.getInfoBranch(),
          this.getInvoiceProductItems(),
          this.getInvoiceServiceItems(),
          this.getDteJsonHeaderInfo(),
          this.getInvoicePayments(),
          this.getCustomer(),
          this.getAllAcounts(),
          this.isDnrInvoice() ? this.getDnrRelatedItems() : Promise.resolve()
        ]);
      }

      await new Promise((resolve) => setTimeout(resolve, 1000));

      this.loading = false;
    },

    async getDteJsonHeaderInfo() {
      try {
        const response = await this.$API.invoices.getDteJsonHeaderByInvoice(
          this.invoice.ID_Invoice
        );

        if (Array.isArray(response) && response.length > 0) {
          this.invoiceDteJson = response[0];
          if (
            !Array.isArray(this.invoiceDteJson.apendice) ||
            this.invoiceDteJson.apendice.length === 0
          ) {
            const invoiceData = await this.$API.invoices.getInvoice(
              this.invoice.ID_Invoice
            );

            if (
              Array.isArray(invoiceData?.apendice) &&
              invoiceData.apendice.length > 0
            ) {
              this.invoice.apendice = invoiceData.apendice;
              this.invoiceDteJson.apendice = invoiceData.apendice;
            }
          }
          return;
        }

        const invoiceData = await this.$API.invoices.getInvoice(
          this.invoice.ID_Invoice
        );

        if (
          Array.isArray(invoiceData?.apendice) &&
          invoiceData.apendice.length > 0
        ) {
          this.invoice.apendice = invoiceData.apendice;
          this.invoiceDteJson.apendice = invoiceData.apendice;
        }
      } catch (err) {
        console.log("Error", err);
      }
    },

    async getDocRelated() {
      if (!this.hasDeleteBtn) {
        return this.$API.invoices
          .getDocRelatedByInvoice(this.invoice.ID_Invoice)
          .then((response) => {
            this.invoiceDocRelated = response;
            return response;
          })
          .catch((err) => {
            console.log("Error", err);
            return [];
          });
      }

      return [];
    },

    isDnrInvoice() {
      return this.invoice.InvoiceType == "DNR";
    },

    async getDnrRelatedItems() {
      if (!this.isDnrInvoice()) {
        return [];
      }

      this.dnrRelatedItemsLoaded = false;

      return this.$API.invoices
        .getDnrRelatedByInvoice(this.invoice.ID_Invoice)
        .then((response) => {
          this.dnrRelatedItems = Array.isArray(response) ? response : [];
          this.dnrRelatedItemsLoaded = true;
          this.syncInvoiceSelection();
          return this.dnrRelatedItems;
        })
        .catch((err) => {
          console.log("Error", err);
          this.dnrRelatedItems = [];
          this.dnrRelatedItemsLoaded = false;
          this.syncInvoiceSelection();
          return [];
        });
    },

    canShowInvalidateInvoice() {
      if (!this.isDnrInvoice()) {
        return true;
      }

      return this.dnrRelatedItemsLoaded && this.dnrRelatedItems.length === 0;
    },

    getInvoiceItemByPkId(pkId) {
      return this.invoiceItems.find(
        (item) => Number(item.Pk_billing_invoices_details) === Number(pkId)
      );
    },

    getInvoiceItemCodeByPkId(pkId) {
      return this.getInvoiceItemByPkId(pkId)?.ID_Item || "";
    },

    getInvoiceItemDescriptionByPkId(pkId) {
      return this.getInvoiceItemByPkId(pkId)?.ItemDescription || "";
    },

    getDnrBilledQuantity(item) {
      if (!this.isDnrInvoice() || !item?.Pk_billing_invoices_details) {
        return 0;
      }

      return this.dnrRelatedItems.reduce((total, relation) => {
        if (Number(relation.Pk_ID_Item) !== Number(item.Pk_billing_invoices_details)) {
          return total;
        }

        return total + parseFloat(relation.QuantityBilled || 0);
      }, 0);
    },

    getVisibleItemQuantity(item) {
      if (!this.isDnrInvoice()) {
        return item?.ItemQuantity || 0;
      }

      const originalQuantity = parseFloat(item?.ItemQuantity || 0);
      const visibleQuantity = originalQuantity - this.getDnrBilledQuantity(item);
      return visibleQuantity > 0 ? visibleQuantity : 0;
    },
    getItemCurrencySymbol(item) {
      return item?.ItemCurrency == "USD" ? "$" : item?.ItemCurrency || "$";
    },
    formatNdNcAmount(item, amount, decimals = 4) {
      return `${this.getItemCurrencySymbol(item)}${this.getNumberValue(
        amount,
        0
      ).toFixed(decimals)}`;
    },
    getNdNcOriginalQuantity(item) {
      return this.getNumberValue(item?.ItemQuantity, 0);
    },
    getNdNcOriginalUnitPrice(item) {
      return this.getNumberValue(item?.ItemUnitPrice, 0);
    },
    getNormalizedNdNcQuantity(item) {
      const maxQuantity = this.getNdNcOriginalQuantity(item);
      let quantity = this.getNumberValue(item?.NdNcQuantity, 0);

      if (quantity < 0) {
        quantity = 0;
      }

      if (quantity > maxQuantity) {
        quantity = maxQuantity;
      }

      return this.roundValue(quantity, 4);
    },
    normalizeNdNcQuantity(item) {
      item.NdNcQuantity = this.getNormalizedNdNcQuantity(item);
    },
    getNormalizedNdNcUnitPrice(item) {
      let unitPrice = this.getNumberValue(
        item?.NdNcUnitPrice,
        this.getNdNcOriginalUnitPrice(item)
      );

      if (unitPrice < 0) {
        unitPrice = 0;
      }

      return this.roundValue(unitPrice, 4);
    },
    normalizeNdNcUnitPrice(item) {
      item.NdNcUnitPrice = this.getNormalizedNdNcUnitPrice(item);
    },
    getNdNcOriginalNetAmount(item) {
      return this.roundValue(
        this.getNumberValue(item?.ItemNoSuj, 0) +
          this.getNumberValue(item?.ItemExenta, 0) +
          this.getNumberValue(item?.ItemNoGravada, 0) +
          this.getNumberValue(item?.ItemGravada, 0)
      );
    },
    getNdNcDiscountPercent(item) {
      const discountPercent = this.getNumberValue(item?.ItemDiscountPercent, 0);

      if (discountPercent > 0) {
        return discountPercent;
      }

      const originalLineGrossAmount = this.roundValue(
        this.getNdNcOriginalQuantity(item) * this.getNdNcOriginalUnitPrice(item)
      );
      const originalDiscountAmount = this.getNumberValue(item?.ItemDiscount, 0);

      if (originalLineGrossAmount <= 0 || originalDiscountAmount <= 0) {
        return 0;
      }

      return this.roundValue(
        (originalDiscountAmount * 100) / originalLineGrossAmount,
        4
      );
    },
    buildNdNcLineAmounts(item) {
      const quantity = this.getNormalizedNdNcQuantity(item);
      const unitPrice = this.getNormalizedNdNcUnitPrice(item);
      const itemdiscountpercent = this.getNdNcDiscountPercent(item);
      const grossAmount = this.roundValue(quantity * unitPrice);
      let itemdiscount = this.roundValue(
        (grossAmount * itemdiscountpercent) / 100
      );

      if (itemdiscount < 0) {
        itemdiscount = 0;
      }

      if (itemdiscount > grossAmount) {
        itemdiscount = grossAmount;
      }

      const lineNetAmount = this.roundValue(grossAmount - itemdiscount);
      const lineAmounts = {
        quantity,
        unitPrice,
        itemdiscountpercent,
        itemdiscount,
        grossAmount,
        lineNetAmount,
        itemnosuj: 0,
        itemexenta: 0,
        itemnogravada: 0,
        itemgravada: 0,
        itemiva: 0,
      };

      if (lineNetAmount <= 0) {
        return lineAmounts;
      }

      const distributionFields = [
        { source: "ItemNoSuj", target: "itemnosuj" },
        { source: "ItemExenta", target: "itemexenta" },
        { source: "ItemNoGravada", target: "itemnogravada" },
        { source: "ItemGravada", target: "itemgravada" },
      ].filter(({ source }) => this.getNumberValue(item?.[source], 0) > 0);

      const originalNetAmount = this.getNdNcOriginalNetAmount(item);

      if (distributionFields.length === 0) {
        lineAmounts.itemgravada = lineNetAmount;
      } else if (originalNetAmount <= 0) {
        lineAmounts[distributionFields[0].target] = lineNetAmount;
      } else {
        let remainingAmount = lineNetAmount;

        distributionFields.forEach((field, index) => {
          const originalAmount = this.getNumberValue(item?.[field.source], 0);
          const currentAmount =
            index === distributionFields.length - 1
              ? remainingAmount
              : this.roundValue(
                  (lineNetAmount * originalAmount) / originalNetAmount
                );

          lineAmounts[field.target] = currentAmount > 0 ? currentAmount : 0;
          remainingAmount = this.roundValue(
            remainingAmount - lineAmounts[field.target]
          );

          if (remainingAmount < 0) {
            remainingAmount = 0;
          }
        });
      }

      const originalGravada = this.getNumberValue(item?.ItemGravada, 0);
      const originalIva = this.getNumberValue(item?.ItemIVA, 0);

      if (lineAmounts.itemgravada > 0 && originalGravada > 0 && originalIva > 0) {
        lineAmounts.itemiva = this.roundValue(
          (lineAmounts.itemgravada * originalIva) / originalGravada
        );
      }

      return lineAmounts;
    },
    getNdNcLineNetAmount(item) {
      return this.buildNdNcLineAmounts(item).lineNetAmount;
    },
    isNdNcItemReadyForBilling(item) {
      const lineAmounts = this.buildNdNcLineAmounts(item);

      return (
        lineAmounts.quantity > 0 &&
        lineAmounts.unitPrice > 0 &&
        lineAmounts.lineNetAmount > 0
      );
    },
    getInvalidNdNcSelectedItems() {
      return this.invoiceSelectItems.filter(
        (item) => !this.isNdNcItemReadyForBilling(item)
      );
    },
    validateNdNcSelection(actionLabel = "continuar con la nota") {
      if (this.invoiceSelectItems.length === 0) {
        this.showAlert(
          "warning",
          "Advertencia",
          "Debe seleccionar al menos un ítem para continuar."
        );
        return false;
      }

      const invalidItems = this.getInvalidNdNcSelectedItems();

      if (invalidItems.length > 0) {
        const itemCodes = invalidItems
          .slice(0, 5)
          .map((item) => item.ID_Item)
          .join(", ");

        this.showAlert(
          "warning",
          "Advertencia",
          `Revise la cantidad y el precio unitario de los ítems seleccionados antes de ${actionLabel}: ${itemCodes}.`
        );
        return false;
      }

      return true;
    },
    getNdNcPreparedItems() {
      return this.invoiceSelectItems.reduce((selectedItems, item) => {
        const lineAmounts = this.buildNdNcLineAmounts(item);

        if (
          lineAmounts.quantity <= 0 ||
          lineAmounts.unitPrice <= 0 ||
          lineAmounts.lineNetAmount <= 0
        ) {
          return selectedItems;
        }

        item.NdNcQuantity = lineAmounts.quantity;
        item.NdNcUnitPrice = lineAmounts.unitPrice;
        selectedItems.push({
          item,
          lineAmounts,
        });

        return selectedItems;
      }, []);
    },
    getNdNcItemsForCreateFlow() {
      return this.getNdNcPreparedItems().map(({ item, lineAmounts }) => ({
        ...item,
        ItemQuantity: lineAmounts.quantity,
        NdNcQuantity: lineAmounts.quantity,
        ItemUnitPrice: lineAmounts.unitPrice,
        NdNcUnitPrice: lineAmounts.unitPrice,
        ItemDiscount: lineAmounts.itemdiscount,
        ItemDiscountPercent: lineAmounts.itemdiscountpercent,
        ItemNoSuj: lineAmounts.itemnosuj,
        ItemExenta: lineAmounts.itemexenta,
        ItemNoGravada: lineAmounts.itemnogravada,
        ItemGravada: lineAmounts.itemgravada,
        ItemIVA: lineAmounts.itemiva,
      }));
    },
    getNdNcDirectItems() {
      return this.getNdNcPreparedItems().map(({ item, lineAmounts }) => ({
          idbranch: item.ID_Branch || this.invoice.ID_Branch,
          idbusiness: item.ID_Business || this.invoice.ID_Business,
          iditem: item.ID_Item,
          itemtype: item.ItemType,
          itemquantity: lineAmounts.quantity,
          itemmeasureunit: item.ItemMeasureUnit || "",
          itemdescription: item.ItemDescription || "",
          itemunitcost: lineAmounts.unitPrice,
          itemdiscount: lineAmounts.itemdiscount,
          itemdiscountpercent: lineAmounts.itemdiscountpercent,
          itemnosuj: lineAmounts.itemnosuj,
          itemexenta: lineAmounts.itemexenta,
          itemnogravada: lineAmounts.itemnogravada,
          itemgravada: lineAmounts.itemgravada,
          itempsv: this.roundValue(this.getNumberValue(item.ItemPsv)),
          itemiva: lineAmounts.itemiva,
          itemcurrency: item.ItemCurrency || "$",
          warehouse: item.Warehouse || "",
          itembatch: item.ID_ItemBatch || "",
          isglobalbranch: this.isEnabledFlag(item.IsGlobalBranch) ? 1 : 0,
          principalbarcode: item.PrincipalBarCode || "",
          itemcomments: item.ItemComments || "",
          pricelistname: item.PriceListName || null,
          LineaAerea: item.LineaAerea || null,
          Boleto: item.Boleto || null,
          Pasajero: item.Pasajero || null,
          Ruta: item.Ruta || null,
        }));
    },
    buildNdNcTotals(items, type) {
      const totals = {
        invoicedescunosuj: 0,
        invoicedescuexenta: 0,
        invoicedescugravada: 0,
        invoiceporcentajedescuento: 0,
        invoicetotaldescu: 0,
        invoicesubtotalventas: 0,
        invoicesubtotal: 0,
        invoicemontototaloperacion: 0,
        invoicetotalexenta: 0,
        invoicetotalnosuj: 0,
        invoicetotalnogravada: 0,
        invoicetotalgravada: 0,
        invoicetotalpagar: 0,
        invoicetotaliva: 0,
        invoiceivarete1: 0,
        invoiceivaperce1: 0,
        invoicereterenta: 0,
        fovial: 0,
        cotrans: 0,
        turismoporalojamiento: 0,
        propina: 0,
      };

      items.forEach((item) => {
        const lineDiscount = this.getNumberValue(item.itemdiscount);
        const lineNoSuj = this.getNumberValue(item.itemnosuj);
        const lineExenta = this.getNumberValue(item.itemexenta);
        const lineNoGravada = this.getNumberValue(item.itemnogravada);
        const lineGravada = this.getNumberValue(item.itemgravada);
        const lineIva = this.getNumberValue(item.itemiva);
        const lineSubtotal = lineNoSuj + lineExenta + lineGravada;
        const lineTaxableGrossTotal = lineGravada > 0 ? lineGravada + lineIva : 0;
        const lineOperationTotal = lineNoSuj + lineExenta + lineTaxableGrossTotal;
        const linePayableTotal = lineOperationTotal + lineNoGravada;

        totals.invoicetotaldescu += lineDiscount;
        totals.invoicesubtotalventas += lineSubtotal;
        totals.invoicesubtotal += lineSubtotal;
        totals.invoicetotalnosuj += lineNoSuj;
        totals.invoicetotalexenta += lineExenta;
        totals.invoicetotalnogravada += lineNoGravada;
        totals.invoicetotalgravada += lineGravada;
        totals.invoicemontototaloperacion += lineOperationTotal;
        totals.invoicetotalpagar += linePayableTotal;
        totals.invoicetotaliva += lineIva;

        if (lineDiscount > 0) {
          if (lineNoSuj > 0) {
            totals.invoicedescunosuj += lineDiscount;
          } else if (lineExenta > 0) {
            totals.invoicedescuexenta += lineDiscount;
          } else {
            totals.invoicedescugravada += lineDiscount;
          }
        }
      });

      const baseDiscountPercentage =
        totals.invoicetotaldescu + totals.invoicesubtotal;

      if (["CCF", "DNC", "DND"].includes(type) && baseDiscountPercentage > 0) {
        totals.invoiceporcentajedescuento = this.roundValue(
          (totals.invoicetotaldescu * 100) / baseDiscountPercentage,
          2
        );
      }

      const businessLegalAgentRetain = this.isEnabledFlag(
        this.infobusiness?.LegalAgentRetain
      );
      const customerLegalAgentRetain = this.isEnabledFlag(
        this.getFirstValue(
          [this.customer?.LegalAgentRetain, this.customer?.legalagentretain],
          0
        )
      );

      if (
        !businessLegalAgentRetain &&
        (this.getNumberValue(this.invoice.InvoiceIvaRete1) > 0 ||
          totals.invoicetotalgravada >= 100)
      ) {
        totals.invoiceivarete1 = this.roundValue(
          totals.invoicetotalgravada * 0.01,
          2
        );
        totals.invoicetotalpagar -= totals.invoiceivarete1;
      }

      if (
        businessLegalAgentRetain &&
        !customerLegalAgentRetain &&
        totals.invoicetotalgravada >= 100
      ) {
        totals.invoiceivaperce1 = this.roundValue(
          totals.invoicetotalgravada * 0.01,
          2
        );
        totals.invoicetotalpagar += totals.invoiceivaperce1;
      }

      Object.keys(totals).forEach((key) => {
        totals[key] = this.roundValue(totals[key], 2);
      });

      return totals;
    },
    buildNdNcHeader(type, items) {
      const isBusiness = this.isEnabledFlag(
        this.getFirstValue(
          [
            this.customer?.Is_a_Business,
            this.customer?.Is_a_business,
            this.hasValue(this.invoice.InvoiceNRC) ? 1 : 0,
          ],
          0
        )
      );
      const isPublicEntity = this.isEnabledFlag(
        this.getFirstValue(
          [this.customer?.Is_a_PublicEntity, this.customer?.Is_a_publicentity],
          0
        )
      );
      const totals = this.buildNdNcTotals(items, type);
      const totalToPay = this.getNumberValue(totals.invoicetotalpagar);

      return {
        invoicedate: this.formatDateForInvoice(),
        invoicetype: type,
        idcustomer: this.invoice.ID_Customer || this.customer?.ID_Customer || "",
        invoicename: this.getFirstValue(
          [this.invoice.InvoiceName, this.customer?.LegalName, this.customer?.BusinessName],
          ""
        ),
        invoiceaddress: this.getFirstValue(
          [this.invoice.InvoiceAddress, this.customer?.LegalAddress, this.customer?.Address],
          ""
        ),
        invoiceaddress2: this.getFirstValue(
          [this.invoice.InvoiceAddress2, this.customer?.Address],
          null
        ),
        invoicenrc: this.getFirstValue(
          [this.invoice.InvoiceNRC, this.customer?.LegalNRC],
          ""
        ),
        invoicenit: this.getFirstValue(
          [this.invoice.InvoiceNIT, this.customer?.LegalNIT],
          ""
        ),
        invoicedui: this.getFirstValue(
          [this.invoice.InvoiceDUI, this.customer?.dui, this.customer?.DUI],
          ""
        ),
        invoicesector: this.getFirstValue(
          [this.invoice.InvoiceSector, this.customer?.LegalSector],
          ""
        ),
        invoiceentity: this.getFirstValue(
          [this.invoice.InvoiceEntity, this.customer?.LegalEntity],
          ""
        ),
        invoicepaymenttype: null,
        invoicetaxpayersize: this.getFirstValue(
          [this.invoice.InvoiceTaxPayerSize, this.customer?.LegalTaxPayerSize],
          ""
        ),
        invoiceisnontaxable: this.isEnabledFlag(
          this.getFirstValue(
            [this.invoice.InvoiceIsNonTaxable, this.customer?.LegalIsNonTaxable],
            0
          )
        ),
        invoicecurrency: this.getFirstValue([this.invoice.InvoiceCurrency], "$"),
        invoiceinternalnote: this.invoice.InvoiceInternalNote || "",
        invoicestatus: 1,
        invoicestatusdescription: "Cancelada",
        invoicecreditday: this.invoice.InvoiceCreditDay || 0,
        invoicereference: this.invoice.InvoiceReference || "",
        ...totals,
        invoicetotalletras: numberToText(totalToPay),
        idbranch: this.invoice.ID_Branch || this.searchbusiness.branch || "",
        idbusiness:
          this.invoice.ID_Business || this.searchbusiness.business || "",
        isglobalbranch: this.isEnabledFlag(this.invoice.IsGlobalBranch) ? 1 : 0,
        ID_Seller: this.invoice.ID_Seller || "",
        MoneyReturn: 0,
        Flete: 0,
        Seguro: 0,
        fovial: 0,
        cotrans: 0,
        zoneclient: this.getFirstValue(
          [this.invoice.ZoneClient, this.customer?.ZoneClient],
          ""
        ),
        portofdeparture: this.invoice.PortOfDeparture || null,
        shipmentno: this.invoice.ShipmentNo || null,
        containerno: this.invoice.ContainerNo || null,
        blno: this.invoice.BlNo || null,
        vesselvoyage: this.invoice.VesselVoyage || null,
        usadfa: this.invoice.UsadFa || null,
        termsofpayment: this.invoice.TermsOfPayment || null,
        codincoterms: this.invoice.CodIncoterms || null,
        descincoterms: this.invoice.DescIncoterms || null,
        stockproductsinreserve: 0,
        CheckTurismoPorAlojamiento: 0,
        CheckPriceWithoutIvaCCF: this.isEnabledFlag(
          this.invoice.CheckPriceWithoutIvaCCF
        )
          ? 1
          : 0,
        InventoryStatus: 0,
        BccEmailsCustomer: this.invoice.BccEmailsCustomer || null,
        ventaterceronit: this.invoice.VentaTerceroNit || null,
        ventaterceronombre: this.invoice.VentaTerceroNombre || null,
        FexZona: this.getNumberValue(this.invoice.FexZona),
        PropinaStatus: 0,
        ID_Technical: this.invoice.ID_Technical || null,
        rulestoshowcomments: this.getNumberValue(this.invoice.RulesToShowComments),
        codpointsale: localStorage.getItem("codPointSale"),
        payments: [],
        pospayments: false,
        firstname: this.customer?.FirstName || "",
        lastname: this.customer?.LastName || "",
        phonenumber: this.customer?.PhoneNumber || "",
        mobilenumber: this.getFirstValue(
          [
            this.customer?.MobileNumber,
            this.customer?.PhoneNumber,
            this.invoiceDteJson?.ReceptorTelefono,
          ],
          ""
        ),
        email: this.getFirstValue(
          [
            this.customer?.Email,
            this.customer?.BusinessEmail,
            this.customer?.BusinessContactEmail,
            this.invoiceDteJson?.ReceptorCorreo,
          ],
          ""
        ),
        address: this.getFirstValue(
          [this.customer?.Address, this.invoice.InvoiceAddress],
          ""
        ),
        country: this.getFirstValue(
          [this.customer?.Country, "El Salvador"],
          "El Salvador"
        ),
        countrymh: this.customer?.CountryMH || "",
        department: this.getFirstValue(
          [
            this.invoiceDteJson?.ReceptorDireccionDepartamento,
            this.customer?.Department,
          ],
          ""
        ),
        municipality: this.getFirstValue(
          [
            this.invoiceDteJson?.ReceptorDireccionMunicipio,
            this.customer?.Municipality,
          ],
          ""
        ),
        codactividad: this.getFirstValue(
          [this.invoiceDteJson?.ReceptorCodActividad, this.customer?.codActividad],
          ""
        ),
        descactividad: this.getFirstValue(
          [this.invoiceDteJson?.ReceptorDescActividad, this.customer?.descActividad],
          ""
        ),
        iddocumenttype: this.getFirstValue(
          [this.customer?.ID_DocumentType, this.invoiceDteJson?.ReceptorTipoDocumento],
          ""
        ),
        isa_business: isBusiness ? 1 : 0,
        isa_publicentity: isPublicEntity ? 1 : 0,
        businessname: this.getFirstValue(
          [this.customer?.BusinessName, this.invoice.InvoiceName],
          ""
        ),
        businesscontactmobile: this.getFirstValue(
          [
            this.customer?.BusinessContactMobile,
            this.customer?.BusinessMobileNumber,
            this.customer?.BusinessPhone,
            this.invoiceDteJson?.ReceptorTelefono,
          ],
          ""
        ),
        businesscontactemail: this.getFirstValue(
          [
            this.customer?.BusinessContactEmail,
            this.customer?.BusinessEmail,
            this.customer?.Email,
            this.invoiceDteJson?.ReceptorCorreo,
          ],
          ""
        ),
        legalagentretain: this.isEnabledFlag(this.customer?.LegalAgentRetain)
          ? 1
          : 0,
        legalreterenta: this.isEnabledFlag(this.customer?.LegalReteRenta) ? 1 : 0,
        propina: 0,
      };
    },
    buildNdNcResultMessage(response, status, message) {
      let resultMessage = `${message}<br/><br/>`;
      resultMessage += `Estado: ${response.estado || status || "SIN ESTADO"}<br/>`;

      if (response?.billingDteJsonHeader?.ID_Invoice) {
        this.invoiceDncOrDndToDeleting = response.billingDteJsonHeader.ID_Invoice
        resultMessage += `ID Factura: ${response.billingDteJsonHeader.ID_Invoice}<br/>`;
      }

      if (response?.descripcionMsg) {
        resultMessage += `Mensaje del DTE: <br/> - ${response.descripcionMsg}<br/>`;
      }

      const observations = Array.isArray(response?.observaciones)
        ? response.observaciones
        : [];

      if (observations.length > 0) {
        resultMessage += "Observaciones DTE: <br/>";
        observations.forEach((observation) => {
          resultMessage += `- ${observation}<br/>`;
        });
      } else if (status !== "PROCESADO") {
        resultMessage += "Observaciones DTE: <br/>- Ninguna observación<br/>";
      }

      return resultMessage;
    },
    async directInvoiceNdNc(type) {
      if (!this.invoice?.CodigoGeneracion) {
        this.showAlert(
          "warning",
          "Advertencia",
          "La factura relacionada no tiene código de generación válido."
        );
        return;
      }

      if (!this.validateNdNcSelection("facturar la nota")) {
        return;
      }

      const items = this.getNdNcDirectItems();

      if (items.length === 0) {
        this.showAlert(
          "warning",
          "Advertencia",
          "Debe seleccionar al menos un ítem con cantidad y precio unitario válidos para facturar la nota."
        );
        return;
      }

      const ndornc = {
        Type: type,
        TipoDocumentoRelacionado: "03",
        TipoGeneracionRelacionado: 2,
        NumeroDocumentoRelacionado: this.invoice.CodigoGeneracion,
        FechaEmisionRelacionado: this.invoice.InvoiceDate,
        ApplyRete1: this.getNumberValue(this.invoice.InvoiceIvaRete1) > 0,
      };

      const header = this.buildNdNcHeader(type, items);
      const noteLabel = type === "DNC" ? "nota de crédito" : "nota de débito";

      this.loading = true;

      try {
        const resp = await this.submitInvoiceAttempt(key => this.$API.invoices.createInvoice({
          header,
          items,
          user: this.userinfo.id,
          invalid: null,
          ndornc,
          contingency: null,
          UseReserveWarehouse: this.userinfo.usereservewarehouse || 0,
          ServicioDeProPinas: null,
          MarkAsBilledItems: null,
        }, key));

        if (!resp?.success) {
          throw resp?.data || resp;
        }

        const response = resp.data || {};

        if (response.estado === "PROCESADO") {
          this.showAlert(
            "successHtml",
            `Facturación de ${noteLabel} realizada`,
            this.buildNdNcResultMessage(
              response,
              "PROCESADO",
              `Se ha procesado la ${noteLabel}.`
            ),
            "reloadInfoInvalidInvoice"
          );
        } else if (response.estado === "CONTINGENCIA") {
          this.showAlert(
            "successHtml",
            "DTE en contingencia",
            this.buildNdNcResultMessage(
              response,
              "CONTINGENCIA",
              `La ${noteLabel} se guardó en estado de contingencia.`
            ),
            "reloadInfoInvalidInvoice"
          );
        } else if (response.estado === "FIRMADOR") {
          this.showAlert(
            "dangerHtml",
            "Error de firmador",
            this.buildNdNcResultMessage(
              response,
              "FIRMADOR",
              `La ${noteLabel} fue rechazada por el firmador.`
            ),
            "reloadInfoDeletingInvoice"
          );
        } else {
          this.showAlert(
            "dangerHtml",
            "DTE rechazado",
            this.buildNdNcResultMessage(
              response,
              "RECHAZADO",
              `La ${noteLabel} fue rechazada por el Ministerio de Hacienda.`
            ),
            "reloadInfoDeletingInvoice"
          );
        }
      } catch (error) {
        const message = this.$parseError
          ? this.$parseError(error)
          : error?.message || "No se pudo facturar la nota seleccionada.";
        this.showAlert("danger", "Error", message);
      } finally {
        this.loading = false;
      }
    },

    getDnrRelationsByItem(item) {
      if (!this.isDnrInvoice() || !item?.Pk_billing_invoices_details) {
        return [];
      }

      return this.dnrRelatedItems.filter(
        (relation) => Number(relation.Pk_ID_Item) === Number(item.Pk_billing_invoices_details)
      );
    },

    openDnrRelatedDialog(item) {
      this.selectedDnrRelatedItem = item;
      this.showDnrRelatedDialog = true;
    },

    getSelectedDnrRelations() {
      return this.getDnrRelationsByItem(this.selectedDnrRelatedItem);
    },

    isInvoiceItemSelectable(item) {
      if (item.ID_Item === "SERVPROPINAS") {
        return false;
      }

      if (!this.isDnrInvoice()) {
        return true;
      }

      return this.getVisibleItemQuantity(item) > 0;
    },

    getSelectableInvoiceItems() {
      return this.invoiceItems.filter((item) => this.isInvoiceItemSelectable(item));
    },

    syncInvoiceSelection() {
      this.invoiceSelectItems = this.invoiceSelectItems.filter((item) =>
        this.isInvoiceItemSelectable(item)
      );

      const selectableItemsLength = this.getSelectableInvoiceItems().length;
      this.selectAll =
        selectableItemsLength > 0 &&
        this.invoiceSelectItems.length === selectableItemsLength;
    },

    async getInvoiceProductItems() {
      return this.$API.invoices
        .getInvoiceProductItemsWithStock(this.invoice.ID_Invoice)
        .then((response) => {
          if (response != []) {
            response.map((el) => {
              const uuid = generateUUID();
              this.invoiceItems.push({
                ...el,
                uuid: uuid,
                NdNcQuantity: this.getNumberValue(el.ItemQuantity, 0),
                NdNcUnitPrice: this.getNumberValue(el.ItemUnitPrice, 0),
              });
              this.totalItemsPrice +=
                el.ItemGravada + el.ItemExenta + el.ItemNoSuj;
            });
          }
          return response;
        })
        .catch((err) => {
          console.log("Error", err);
          return [];
        });
    },

    async getInvoiceServiceItems() {
      return this.$API.invoices
        .getInvoiceServiceItems(this.invoice.ID_Invoice)
        .then((response) => {
          if (response != []) {
            response.map((el) => {
              const uuid = generateUUID();
              this.invoiceItems.push({
                ...el,
                uuid: uuid,
                NdNcQuantity: this.getNumberValue(el.ItemQuantity, 0),
                NdNcUnitPrice: this.getNumberValue(el.ItemUnitPrice, 0),
              });
              this.totalItemsPrice +=
                el.ItemGravada + el.ItemExenta + el.ItemNoSuj;
            });
          }
          return response;
        })
        .catch((err) => {
          console.log("Error", err);
          return [];
        });
    },

    async closeAlert() {
      this.alert.show = false;
      if (this.alert.options == "reload") {
        this.$emit("close");
        this.$store.commit("posData/setReloaders", "reloadBill");
        this.$store.dispatch("reloadData", {
          name: "invoices",
          component: "Invoices",
          unique: true,
        });
      }
      if (this.alert.options == "reloadInfoInvalidInvoice") {
        this.$emit("close");
        this.$store.commit("posData/setReloaders", "reloadHistory");
        this.$store.dispatch("reloadData", {
          name: "invoices",
          component: "Invoices",
          unique: true,
        });
      }
      if (this.alert.options == "reloadInfoDeletingInvoice") {
        /*if (this.invoiceDncOrDndToDeleting) {
          const response = await this.$API.invoices.getInvoiceIsNotBilled({
            ID_Branch: this.invoice.ID_Branch,
            ID_Business: this.invoice.ID_Business,
            ID_Invoice: this.invoiceDncOrDndToDeleting
          });

          if (response.value) {
            let tmpInvoice = await this.$API.invoices.getInvoice(this.invoiceDncOrDndToDeleting)

            if (tmpInvoice) {
              await this.$API.invoices.deleteInvoiceWithInventory(tmpInvoice)
            }
          }
        }*/
        this.invoiceDncOrDndToDeleting = null
        this.$emit("close");
        this.$store.commit("posData/setReloaders", "reloadHistory");
        this.$store.dispatch("reloadData", {
          name: "invoices",
          component: "Invoices",
          unique: true,
        });
      }
      if (this.alert.options == "showInvalid") {
        this.showInvalidAlert = true;
      }
    },
    showAlert(type, header, body, options = null) {
      type = type == null ? "danger" : type;
      this.alert.type = type;
      this.alert.header = header;
      this.alert.body = body;
      this.alert.show = true;
      this.alert.options = options != null ? options : null;
    },
    openEditSelectorsDialog() {
      this.editSelectorsForm = {
        ClasificationRent: this.invoice?.ClasificationRent || null,
        SectorProveedores: this.invoice?.SectorProveedores || null,
        TipoIngresoProveedores: this.invoice?.TipoIngresoProveedores || null,
      };
      this.showEditSelectorsDialog = true;
    },
    closeEditSelectorsDialog() {
      this.showEditSelectorsDialog = false;
      this.editSelectorsLoading = false;
      this.editSelectorsValid = false;
    },
    async saveEditSelectors() {
      const form = this.$refs.editSelectorsFormRef;

      if (form && !form.validate()) {
        this.showAlert(
          "warning",
          "Advertencia",
          "Debe seleccionar una clasificación válida para continuar."
        );
        return;
      }

      if (!this.canEditSelectors) {
        this.showAlert(
          "warning",
          "Advertencia",
          "Solo se pueden editar selectores de comprobantes tipo sujeto excluido (FNS)."
        );
        return;
      }

      this.editSelectorsLoading = true;

      try {
        const payload = {
          ID_Invoice: this.invoice.ID_Invoice,
          ID_Business: this.invoice.ID_Business,
          ClasificationRent: this.editSelectorsForm.ClasificationRent || null,
          SectorProveedores: this.editSelectorsForm.SectorProveedores || null,
          TipoIngresoProveedores: this.editSelectorsForm.TipoIngresoProveedores || null,
        };

        const response = await this.$API.invoices.updateInvoiceSelectors(payload);
        const message = response?.data?.message || response?.message || "Selectores actualizados correctamente.";

        this.invoice.ClasificationRent = payload.ClasificationRent;
        this.invoice.SectorProveedores = payload.SectorProveedores;
        this.invoice.TipoIngresoProveedores = payload.TipoIngresoProveedores;

        this.showAlert("success", "Éxito", message);
        this.closeEditSelectorsDialog();
      } catch (error) {
        const message = error?.response?.data?.message || error?.message || "No se pudieron actualizar los selectores.";
        this.showAlert("danger", "Error", message);
      } finally {
        this.editSelectorsLoading = false;
      }
    },
    getHeaderFooter() {
      let search = {
        ID_Branch: JSON.parse(localStorage.getItem("user")).branch || "",
        ID_Business: JSON.parse(localStorage.getItem("user")).businessid || "",
      };
      this.$API.HF.getHF(search).then((data) => {
        let header = [],
          footer = [];
        header = data.filter((x) => x.State == "1" && x.Type == "Header");
        this.header = header.length > 0 ? JSON.parse(header[0].Body).html : "";
        footer = data.filter((x) => x.State == "1" && x.Type == "Footer");
        this.footer = footer.length > 0 ? JSON.parse(footer[0].Body).html : "";
      });
    },
    async deleteInvoice() {
      this.loading = true;
      const response = await this.$API.invoices.getInvoiceIsNotBilled({
        ID_Branch: this.invoice.ID_Branch,
        ID_Business: this.invoice.ID_Business,
        ID_Invoice: this.invoice.ID_Invoice
      });
      
      if (!response.value) {
        this.loading = false;
        this.showDelAlert = false;
        this.showAlert(
          'warning', 
          'Advertencia',
          'La factura seleccionada ya se encuentra procesada. Por favor recargue el historial de listo para facturar.',
        );
      }
      else {
        this.$API.invoices
          .deleteInvoice(this.invoice.ID_Invoice)
          .then(() => {
            this.loading = false;
            this.showAlert(
              "success",
              "Factura eliminada",
              "La factura se ha eliminado correctamente",
              "reload"
            );
            this.showDelAlert = false;
          })
          .catch(() => {
            this.loading = false;
            this.showAlert(
              "danger",
              "Error",
              "Ha ocurrido un error al eliminar la factura"
            );
            this.showDelAlert = false;
          });
      }
      
    },

    async deleteInvoiceWithInventory() {
      this.loading = true
      const response = await this.$API.invoices.getInvoiceIsNotBilled({
        ID_Branch: this.invoice.ID_Branch,
        ID_Business: this.invoice.ID_Business,
        ID_Invoice: this.invoice.ID_Invoice
      });
      
      if (!response.value) {
        this.loading = false;
        this.showDelAlert2 = false;
        this.showAlert(
          'warning', 
          'Advertencia',
          'La factura seleccionada ya se encuentra procesada. Por favor recargue el historial de listo para facturar.',
        );
      }
      else {
        this.$API.invoices
          .deleteInvoiceWithInventory(this.invoice)
          .then(response => {
            this.loading = false;
            if (response.status) {
              this.showAlert(
                "success",
                "Factura eliminada",
                response.message,
                "reload"
              );
            }
            else {
              this.showAlert(
                "warning",
                "Advertencia",
                response.message,
                "reload"
              );
            }
            this.showDelAlert2 = false;
          })
          .catch(() => {
            this.loading = false;
            this.showAlert(
              "danger",
              "Error",
              "Ha ocurrido un error al eliminar la factura"
            );
            this.showDelAlert2 = false;
          });
      }
    },

    Print() {
      this.$print(this.$refs.print);
    },

    async getInfoBranch() {
      return this.$API.branches
        .findSpecificBranch(this.searchbusiness)
        .then((res) => {
          this.infobusiness = res[0];
          this.branchinfo.AuthFeMode = this.infobusiness.AuthFeMode;
          this.branchinfo.BusinessBillingNRC =
            this.infobusiness.BusinessBillingNRC;
          this.branchinfo.BusinessBillingNIT =
            this.infobusiness.BusinessBillingNIT;
          this.branchinfo.BusinessBillingName =
            this.infobusiness.BusinessBillingName;
          this.refreshNativeDteTemplateAvailability();
          return res;
        })
        .catch((err) => {
          console.log("Error", err);
          return [];
        });
    },
    async refreshNativeDteTemplateAvailability() {
      const resolved = await resolveBranchConfiguredDteTemplate(this.$API, this.branchinfo);
      this.nativeDteTemplateEnabled = Boolean(resolved.eligible);
      return this.nativeDteTemplateEnabled;
    },
    async imprimirFacturaDirecta(){
      // imprimirFactura(this.invoice.ID_Invoice);

      this.loading = true;
      try {
        await imprimirFactura(this.invoice.ID_Invoice, this);
      } catch (error) {
        console.error('Error al imprimir factura:', error);
        this.showAlert(
          "danger",
          "Error",
          "Ha ocurrido un error al imprimir la factura"
        );
      } finally {
        this.loading = false;
      }
      
    },
    getInvoicePrintData() {
      this.invoice.customerInfo = this.customer;

      const header = { ...this.invoice, ...this.invoiceDteJson };
      header.apendice =
        this.invoiceDteJson?.apendice ||
        this.invoiceDteJson?.Apendice ||
        this.invoice?.apendice ||
        this.invoice?.Apendice ||
        null;

      return {
        header,
        user: this.userinfo,
        body: this.invoiceItems,
        branch: this.branchinfo,
        dteJson: this.invoiceDteJson,
        docRelated: this.invoiceDocRelated,
        invoicePayments: this.invoicePayments
      };
    },
    buildPosHeaderForCreate() {
      const header = {
        ...this.invoice,
        ...this.invoiceDteJson,
      };

      header.apendice =
        this.invoiceDteJson?.apendice ||
        this.invoiceDteJson?.Apendice ||
        this.invoice?.apendice ||
        this.invoice?.Apendice ||
        null;

      return header;
    },
    async shouldUseDirectRetryFlow() {
      const retryableStatuses = ["CONTINGENCIA", "RECHAZADO", "NO_PROCESADO"];

      if (!retryableStatuses.includes(this.invoice.FeMhEstado)) {
        return false;
      }

      if (this.invoice.InvoiceType !== "FNS") {
        return false;
      }

      if (!String(this.invoice.ID_Customer || "").startsWith("PROV")) {
        return false;
      }

      try {
        await this.$API.providers.getSpecifiedProvider(this.invoice.ID_Customer, {
          type_provider: 1,
        });

        return true;
      } catch (error) {
        return false;
      }
    },
    buildRetryDteMessage(responseData) {
      if (!responseData) {
        return "El DTE fue reenviado, pero no se recibio detalle adicional.";
      }

      const messageParts = [];

      if (responseData.estado) {
        messageParts.push(`Estado: ${responseData.estado}`);
      }

      if (responseData.descripcionMsg) {
        messageParts.push(`Mensaje del DTE: ${responseData.descripcionMsg}`);
      } else if (responseData.message) {
        messageParts.push(responseData.message);
      }

      if (Array.isArray(responseData.observaciones) && responseData.observaciones.length > 0) {
        messageParts.push(`Observaciones: ${responseData.observaciones.join(", ")}`);
      }

      if (messageParts.length === 0) {
        return "El DTE fue reenviado correctamente.";
      }

      return messageParts.join("\n");
    },
    async refreshInvoiceDetailsAfterRetry() {
      const updatedInvoice = await this.$API.invoices.getInvoice(this.invoice.ID_Invoice);

      Object.keys(this.invoice).forEach((key) => {
        if (!(key in updatedInvoice)) {
          delete this.invoice[key];
        }
      });
      Object.assign(this.invoice, updatedInvoice);

      this.invoiceItems = [];
      this.invoicePayments = [];
      this.invoiceDocRelated = [];
      this.invoiceDteJson = {
        ReceptorDescActividad: null,
      };
      this.invoiceSelectItems = [];
      this.totalItemsPrice = 0;
      this.selectAll = false;

      await Promise.all([
        this.getInvoiceProductItems(),
        this.getInvoiceServiceItems(),
        this.getInvoicePayments(),
        this.getDteJsonHeaderInfo(),
        this.getDocRelated(),
        this.getCustomer(),
      ]);

      this.syncInvoiceSelection();
    },
    async retryDteDirectly() {
      this.loading = true;

      try {
        const response = await this.submitInvoiceAttempt(key => this.$API.invoices.retryDteByInvoice(this.invoice.ID_Invoice, key));

        if (!response?.success) {
          throw response || new Error("No fue posible reenviar el DTE.");
        }

        await this.refreshInvoiceDetailsAfterRetry();

        this.showAlert(
          "success",
          "DTE reenviado",
          this.buildRetryDteMessage(response.data),
          "reloadInfoInvalidInvoice"
        );
      } catch (error) {
        const message =
          error?.message ||
          error?.data?.message ||
          error?.data?.error ||
          "No fue posible reenviar el DTE.";

        this.showAlert("danger", "Error", message);
      } finally {
        this.loading = false;
      }
    },
    async managePrintLetter() {
      const canUseNativeDteTemplate =
        !this.invoice.ID_Invoice.startsWith("TCKS") &&
        await this.refreshNativeDteTemplateAvailability();

      if (!canUseNativeDteTemplate) {
        await this.manageprint({ skipNativeTemplate: true });
        return;
      }

      this.printLetter = {
        show: true,
        data: this.getInvoicePrintData(),
      };
    },
    async manageprint(options = {}) {
      const invoicePrintData = this.getInvoicePrintData();
      const canUseNativeDteTemplate =
        !options.skipNativeTemplate &&
        !this.invoice.ID_Invoice.startsWith("TCKS") &&
        await this.refreshNativeDteTemplateAvailability();

      if (canUseNativeDteTemplate) {
        this.printLetter = {
          show: true,
          data: invoicePrintData,
        };
        this.showFacPrint = true;
        return;
      }


      if (
        JSON.parse(localStorage.getItem("user")).ticketformatfcf &&
        JSON.parse(localStorage.getItem("user")).TipoPlan != "Ecoanual" &&
        (this.invoice.InvoiceType == "FCF" || this.invoice.InvoiceType == "CCF")
      ) {
        this.print3 = {
          show: true,
          data: invoicePrintData,
        };
        this.print = {
          show: true,
          data: invoicePrintData,
        };
      } else {
        if (this.invoice.ID_Invoice.startsWith("TCKS")) {
          this.print2 = {
            show: true,
            data: invoicePrintData,
          };
        } else {
          this.print = {
            show: true,
            data: invoicePrintData,
          };
        }
      }
      this.showFacPrint = true
    },
    managePrintDeliveryDoc() {
      if (
        JSON.parse(localStorage.getItem("user")).ticketformatfcf &&
        JSON.parse(localStorage.getItem("user")).TipoPlan != "Ecoanual" &&
        (this.invoice.InvoiceType == "FCF" || this.invoice.InvoiceType == "CCF")
      ) {
        this.printDeliveryDoc1 = {
          show: true,
          data: {
            header: this.invoice,
            user: this.userinfo,
            body: this.invoiceItems,
            branch: this.branchinfo,
            dteJson: this.invoiceDteJson,
            docRelated: this.invoiceDocRelated,
          },
        };
      } else {
        if (this.invoice.ID_Invoice.startsWith("TCKS")) {
          this.printDeliveryDoc1 = {
            show: true,
            data: {
              header: this.invoice,
              user: this.userinfo,
              body: this.invoiceItems,
              branch: this.branchinfo,
              dteJson: this.invoiceDteJson,
              docRelated: this.invoiceDocRelated,
            },
          };
        } else {
          this.printDeliveryDoc1 = {
            show: true,
            data: {
              header: this.invoice,
              user: this.userinfo,
              body: this.invoiceItems,
              branch: this.branchinfo,
              dteJson: this.invoiceDteJson,
              docRelated: this.invoiceDocRelated,
            },
          };
        }
      }
    },
    async editInvoice() {
      if (await this.shouldUseDirectRetryFlow()) {
        await this.retryDteDirectly();
        return;
      }

      if (this.invoicePayments.length > 0) {
        this.invoice.payments = this.invoicePayments;
      } else {
        this.invoice.payments = [];
      }
      await this.getDteJsonHeaderInfo();
      const header = this.buildPosHeaderForCreate();

      this.$store.commit("posData/setReloaders", "reloadCreate");
      this.$store.commit("posData/setHeader", header);
      this.$store.commit("posData/setBody", this.invoiceItems);
      this.$store.commit("posData/setInvalid", null);
      this.$store.commit("posData/setCopy", null);
      this.$store.commit("posData/setForceBlocking", null);
      if( this.invoiceDocRelated.length > 0 ) {
        const [
          {
            NumeroDocumentoRelacionado,
            FechaEmisionRelacionado,
            TipoGeneracionRelacionado,
            TipoDocumentoRelacionado
          }
        ] = this.invoiceDocRelated;

        this.$store.commit("posData/setNDorNC", {
          Type: this.invoice.InvoiceType,
          TipoDocumentoRelacionado,
          TipoGeneracionRelacionado,
          NumeroDocumentoRelacionado,
          FechaEmisionRelacionado,
        } );
      } else {
        this.$store.commit("posData/setNDorNC", null);
      }
      this.$store.commit("posData/setQuote", null);

      if (
        this.invoice.FeMhEstado == "CONTINGENCIA" ||
        this.invoice.FeMhEstado == "RECHAZADO" ||
        this.invoice.FeMhEstado == "NO_PROCESADO"
      ) {
        this.$store.commit("posData/setContingency", {
          CodigoGeneracion: this.invoice.CodigoGeneracion,
          NumeroControl: this.invoice.NumeroControl,
        });
      } else {
        this.$store.commit("posData/setContingency", null);
      }

      this.$emit("close");
      this.$store.commit("posData/changeView", "tab-1");
    },

    editQuote() {
      if (this.invoicePayments.length > 0) {
        this.invoice.payments = this.invoicePayments;
      } else {
        this.invoice.payments = [];
      }

      this.$store.commit("posData/setReloaders", "reloadCreate");
      this.$store.commit("posData/setHeader", this.invoice);
      this.$store.commit("posData/setBody", this.invoiceItems);
      this.$store.commit("posData/setInvalid", null);
      this.$store.commit("posData/setCopy", null);
      this.$store.commit("posData/setForceBlocking", null);
      if( this.invoiceDocRelated.length > 0 ) {
        const [
          {
            NumeroDocumentoRelacionado,
            FechaEmisionRelacionado,
            TipoGeneracionRelacionado,
            TipoDocumentoRelacionado
          }
        ] = this.invoiceDocRelated;

        this.$store.commit("posData/setNDorNC", {
          Type: this.invoice.InvoiceType,
          TipoDocumentoRelacionado,
          TipoGeneracionRelacionado,
          NumeroDocumentoRelacionado,
          FechaEmisionRelacionado,
        } );
      } else {
        this.$store.commit("posData/setNDorNC", null);
      }
      this.$store.commit("posData/setQuote", "edit");

      if (
        this.invoice.FeMhEstado == "CONTINGENCIA" ||
        this.invoice.FeMhEstado == "RECHAZADO" ||
        this.invoice.FeMhEstado == "NO_PROCESADO"
      ) {
        this.$store.commit("posData/setContingency", {
          CodigoGeneracion: this.invoice.CodigoGeneracion,
          NumeroControl: this.invoice.NumeroControl,
        });
      } else {
        this.$store.commit("posData/setContingency", null);
      }

      this.$emit("close");
      this.$store.commit("posData/changeView", "tab-1");
    },

    async copyInvoice() {
      if (this.invoicePayments.length > 0) {
        this.invoice.payments = this.invoicePayments;
      } else {
        this.invoice.payments = [];
      }
      await this.getDteJsonHeaderInfo();
      const header = this.buildPosHeaderForCreate();

      this.$store.commit("posData/setReloaders", "reloadCreate");
      this.$store.commit("posData/setHeader", header);
      this.$store.commit("posData/setBody", this.invoiceItems);
      this.$store.commit("posData/setInvalid", null);

      if( this.invoiceDocRelated.length > 0 ) {
        const [
          {
            NumeroDocumentoRelacionado,
            FechaEmisionRelacionado,
            TipoGeneracionRelacionado,
            TipoDocumentoRelacionado
          }
        ] = this.invoiceDocRelated;

        this.$store.commit("posData/setNDorNC", {
          Type: this.invoice.InvoiceType,
          TipoDocumentoRelacionado,
          TipoGeneracionRelacionado,
          NumeroDocumentoRelacionado,
          FechaEmisionRelacionado,
        } );
      } else {
        this.$store.commit("posData/setNDorNC", null);
      }
      
      this.$store.commit("posData/setQuote", null);
      this.$store.commit("posData/setContingency", null);
      this.$store.commit("posData/setCopy", true);
      this.$store.commit("posData/setForceBlocking", null);

      this.$emit("close");
      this.$store.commit("posData/changeView", "tab-1");

    },

    invalidDTE(invForm) {
      if (this.invoicePayments.length > 0) {
        this.invoice.payments = this.invoicePayments;
      } else {
        this.invoice.payments = [];
      }

      invForm.header = {
        ID_Invoice: this.invoice.ID_Invoice,
        InvoiceDate: this.invoice.InvoiceDate,
        InvoiceType: this.invoice.InvoiceType,
      };
      invForm.items = this.invoiceItems;

      if (!invForm.motivoInvalid || invForm.motivoInvalid.length < 5) {
        this.showInvalidAlert = false;
        this.showAlert(
          "warning",
          "Advertencia",
          "El motivo debe tener al menos 5 caracteres para poderse invalidar",
          "showInvalid"
        );
        return;
      }

      if (invForm.tipo == 1 || invForm.tipo == 3) {
        this.$store.commit("posData/setReloaders", "reloadCreate");
        this.$store.commit("posData/setHeader", this.invoice);
        this.$store.commit("posData/setBody", this.invoiceItems);
        this.$store.commit("posData/setNDorNC", null);
        this.$store.commit("posData/setQuote", null);
        this.$store.commit("posData/setCopy", null);
        this.$store.commit("posData/setForceBlocking", null);
        this.$store.commit("posData/setInvalid", {
          ID_Invoice: this.invoice.ID_Invoice,
          InvalidForm: invForm,
          InvalidType: null,
          ID_Business: this.invoice.ID_Business,
          ID_Branch: this.invoice.ID_Branch,
          user: JSON.parse(localStorage.getItem("user")).id,
        });
        this.$emit("close");
        this.$store.commit("posData/changeView", "tab-1");
      }

      if (invForm.tipo == 2) {
        this.showInvalidAlert = false;
        this.loading = true;
        this.$API.invoices
          .invalidInvoice({
            ID_Invoice: this.invoice.ID_Invoice,
            InvalidForm: invForm,
            InvalidType: null,
            ID_Business: this.invoice.ID_Business,
            ID_Branch: this.invoice.ID_Branch,
            user: JSON.parse(localStorage.getItem("user")).id,
          })
          .then((response) => {
            this.loading = false;
            if (response.estado == "PROCESADO") {
              let mensaje =
                "Se ha realizado y procesado la invalidación <br/><br/>";
              mensaje += "Estado: " + response.estado + "<br/>";
              mensaje +=
                "Mensaje del DTE: <br/> - " + response.descripcionMsg + "<br/>";
              mensaje += "Observaciones DTE: <br/>";
              if (response.observaciones.length == 0) {
                mensaje += "- Ninguna observación <br/>";
              } else {
                for (let i = 0; i < response.observaciones.length; i++) {
                  mensaje += "- " + response.observaciones[i] + "<br/>";
                }
              }

              this.showAlert(
                "successHtml",
                "Invalidación realizada",
                mensaje,
                "reloadInfoInvalidInvoice"
              );
            } else {
              let mensaje =
                "Se ha rechazado la invalidación, tomar en cuenta las observaciones del Ministerio de Hacienda y realizarla de nuevo.<br/><br/>";
              mensaje += "Estado: " + response.estado + "<br/>";
              mensaje +=
                "Mensaje del DTE: <br/> - " + response.descripcionMsg + "<br/>";
              mensaje += "Observaciones DTE: <br/>";
              if (response.observaciones.length == 0) {
                mensaje += "- Ninguna observación <br/>";
              } else {
                for (let i = 0; i < response.observaciones.length; i++) {
                  mensaje += "- " + response.observaciones[i] + "<br/>";
                }
              }

              this.showAlert(
                "successHtml", 
                "Invalidación rechazada", 
                mensaje, 
                "reloadInfoInvalidInvoice"
              );
            }
          })
          .catch((err) => {
            this.loading = false;
            this.showInvalidAlert = false;
            let message =
              "Ocurrio un error crítico al realizar la invalidación. Luego de 3 intentos sin éxito contáctese con el administrador. ";
            message += "" + JSON.stringify(err);
            this.showAlert("warning", "Advertencia", message);
          });
      }
    },
    toggleSelectAll() {
      if (this.selectAll) {
        this.invoiceSelectItems = this.getSelectableInvoiceItems();
      } else {
        this.invoiceSelectItems = [];
      }
    },
    checkItemChanged(item) {
      const index = this.invoiceSelectItems.findIndex(
        (selectedItem) => (
          selectedItem.ID_Item === item.ID_Item &&
          selectedItem.uuid === item.uuid
        )
      );
      if (index > -1) {
        this.invoiceSelectItems.splice(index, 1);
      } else {
        this.invoiceSelectItems.push(item);
      }
    },
    createAnInvoiceFrom() {
      if (this.invoicePayments.length > 0) {
        this.invoice.payments = this.invoicePayments;
      } else {
        this.invoice.payments = [];
      }

      const invoiceItemsToSend = this.isDnrInvoice()
        ? this.invoiceSelectItems.map((item) => ({
            ...item,
            ItemQuantity: this.getVisibleItemQuantity(item)
          }))
        : this.invoiceSelectItems;

      this.$store.commit("posData/setReloaders", "reloadCreate");
      this.$store.commit("posData/setHeader", this.invoice);
      this.$store.commit("posData/setBody", invoiceItemsToSend);
      this.$store.commit("posData/setInvalid", null);
      this.$store.commit("posData/setNDorNC", null);
      this.$store.commit("posData/setQuote", null);
      this.$store.commit("posData/setContingency", null);
      this.$store.commit("posData/setCopy", true);
      this.$store.commit("posData/setForceBlocking", true);

      this.$emit("close");
      this.$store.commit("posData/changeView", "tab-1");
    },
    addNDorNC(type) {
      if (
        this.invoice.IsNDorNC == true &&
        this.DoDndDncInHistoryInvoices &&
        !this.validateNdNcSelection("continuar con la nota")
      ) {
        return;
      }

      const invoiceItemsToSend =
        this.invoice.IsNDorNC == true && this.DoDndDncInHistoryInvoices
          ? this.getNdNcItemsForCreateFlow()
          : this.invoiceSelectItems;

      this.$store.commit("posData/setReloaders", "reloadCreate");
      this.$store.commit("posData/setHeader", this.invoice);
      this.$store.commit("posData/setBody", invoiceItemsToSend);
      this.$store.commit("posData/setInvalid", null);
      this.$store.commit("posData/setQuote", null);
      this.$store.commit("posData/setCopy", null);
      this.$store.commit("posData/setForceBlocking", null);
      this.$store.commit("posData/setNDorNC", {
        Type: type,
        TipoDocumentoRelacionado: "03",
        TipoGeneracionRelacionado: 2,
        NumeroDocumentoRelacionado: this.invoice.CodigoGeneracion,
        FechaEmisionRelacionado: this.invoice.InvoiceDate,
        ApplyRete1: this.invoice.InvoiceIvaRete1 > 0 ?  true : false
      });
      this.$emit("close");
      this.$store.commit("posData/changeView", "tab-1");
    },
    async getInvoicePayments() {
      return this.$API.invoices
        .getInvoicePayments(this.invoice.ID_Invoice)
        .then((response) => {
          if (response != null) {
            this.invoicePayments = [];
            response.forEach((payment) => {
              payment.TotalPayment = parseFloat(payment.TotalPayment).toFixed(
                2
              );
              this.invoicePayments.push(payment);
            });
          }
          return response;
        })
        .catch((err) => {
          console.log("Error", err);
          return [];
        });
    },
    getDateFormatted(val){
      if (!val) return '';
      
      const fecha = new Date(val);
      return fecha.toLocaleString("es-SV", {
        day: "2-digit",
        month: "2-digit",
        year: "numeric",
        hour: "2-digit",
        minute: "2-digit",
        second: "2-digit",
        hour12: false
      });
    },
    // Emitir evento para abrir modal de frecuencia en el componente padre
    openFrequencyModal() {
      this.$emit('openFrequencyModal', this.invoice);
    },
      formatDateDDMMYYYY(dateString) {
        if (!dateString) return '';
      
        // Si viene en formato yyyy-mm-dd, convertir a dd/mm/yyyy
        if (dateString.includes('-')) {
          const [yyyy, mm, dd] = dateString.split('-');
          return `${dd}/${mm}/${yyyy}`;
        }
      
        // Si ya estÃ¡ en formato dd/mm/yyyy, devolverlo tal cual
        if (dateString.includes('/')) {
          return dateString;
        }
      
        return dateString;
      }
  },
};
</script>

<style scoped>
.tabs {
  width: 100%;
  padding: 10px;
  background-color: rgba(60, 60, 60, 1);
  color: white !important;
  border-style: solid;
  border-color: black;
  border-width: 1px;
  border-radius: 10px;
}

.summaryMobile {
  display: none;
}

.ndnc-quantity-field {
  max-width: 150px;
}

.ndnc-unit-price-field {
  max-width: 170px;
}

.tabs:hover {
  background-color: rgba(80, 80, 80, 1);
  cursor: pointer;
}

.tabsContent:hover {
  background-color: #ffb266;
  cursor: pointer;
}

.tabsContent {
  width: 100%;
  padding: 10px;
  background-color: #f29d35;
  color: white !important;
  border-style: solid;
  border-color: black;
  border-width: 1px;
  border-radius: 10px;
}

table {
  width: 100%;
}

.btnsave {
  background-color: #3498db !important;
  color: white;
}

.btndelete {
  background-color: #e3191e !important;
  color: white;
}

.btndisable {
  background-color: #41464c !important;
  color: white;
}

.form-control {
  background: #d6eaf3;
  border: 1px solid #1976d2;
  text-align: center;
  max-width: 80px;
  height: 30px;
  border-radius: 20px;
}

.v-application .mx-2 {
  margin-right: 0px !important;
}

.v-application .mx-3 {
  margin-right: 30px !important;
  display: flex;
  flex-direction: column;
}

.dialog-content {
  max-height: 90vh; /* Establece una altura máxima para el contenido */
  overflow-y: auto;
}

.wrapper-bar {
  display: flex;
  background: #41464c;
  color: white;
  padding: 10px;
  border-radius: 10px;

  z-index: 88888888 !important;
  justify-content: flex-start;
  text-align: center;
  position: sticky;
  flex-wrap: wrap;
  gap: 10px;
  align-items: center;
}

@media only screen and (min-width: 1366px) {
  .wrapper-bar {
    justify-content: space-between;
  }
}
@media only screen and (max-width: 1174px) {
  .summaryMobile {
    display: block;
  }
  .summaryDesktop {
    display: none !important;
  }
}
@media (max-width: 600px) {
  .toolbar-container {
    flex-direction: column;
  }
  .dialog-content {
    max-height: 90vh; /* Establece una altura máxima para el contenido */
    overflow-y: auto;
  }
  /* Ajustes adicionales para mejorar la presentación en móviles */
  .toolbar-container > * {
    margin-bottom: 8px; /* Espacio entre elementos */
  }
  .mobile {
    justify-content: center;
    flex-direction: column;
  }
  .center {
    align-items: center !important;
  }
  .summaryMobile {
    justify-content: center;
    flex-direction: column;
  }
}
</style>
